@if (!isPageReady) {
<div class="spur-page-loader homepage-page-loader" role="status" aria-live="polite" aria-busy="true">
    <div class="spur-page-loader__inner">
        <div class="spur-page-loader__visual" aria-hidden="true">
            <span class="spur-page-loader__orbit"></span>
            <span class="spur-page-loader__mark"></span>
        </div>
        <p class="spur-page-loader__brand">Spur Experiences</p>
        <p class="spur-page-loader__line">Loading homepage…</p>
    </div>
</div>
} @else {
@if(loading){
<div class="loader">
    <div class="loaderImg"><img [src]="web_cdn_url+'assets/images/loading.gif'"
            alt /></div>
</div>
}
<section class="hero-wrapper">
    <div class="hero-media-shell"
        [class.homeSlider]="bannerMode === 'seasonal-images'">
        @switch (bannerMode) {
        @case ('seasonal-images') {
        @if (images?.length > 0) {
        @if (!isSliderReady) {
        <div class="gallery-item-container">
            <picture>
                <source media="(max-width: 767px)"
                    [srcset]="pictureSrcset(images[0]?.responsiveImage || images[0]?.itemImageSrc, [480, 768])"
                    sizes="100vw">
                <source media="(min-width: 768px)"
                    [srcset]="pictureSrcset(images[0]?.itemImageSrc, [1200])"
                    sizes="100vw">
                <img
                    [src]="images[0]?.itemImageSrc ? images[0]?.itemImageSrc + '?width=1200' : ''"
                    sizes="100vw"
                    class="gallery-image" [alt]="images[0]?.alt"
                    fetchpriority="high" loading="eager" />
            </picture>
        </div>
        } @else {
        <p-galleria [value]="images" [(activeIndex)]="activeIndex"
            [numVisible]="5" [circular]="true"
            [autoPlay]="true" [showThumbnails]="false"
            [showItemNavigators]="false"
            [responsiveOptions]="responsiveOptions" showIndicatorsOnItem="false"
            styleClass="hero-galleria">
            <ng-template #item>
                <div class="gallery-item-container">
                    <picture>
                        <source media="(max-width: 767px)"
                            [srcset]="pictureSrcset(activeItem?.responsiveImage || activeItem?.itemImageSrc, [480, 768])"
                            sizes="100vw">
                        <source media="(min-width: 768px)"
                            [srcset]="pictureSrcset(activeItem?.itemImageSrc, [1200])"
                            sizes="100vw">
                        <img
                            [src]="activeItem?.itemImageSrc ? activeItem?.itemImageSrc + '?width=1200' : ''"
                            sizes="100vw" class="gallery-image"
                            [alt]="activeItem?.alt" fetchpriority="high"
                            loading="eager" />
                    </picture>
                </div>
            </ng-template>
        </p-galleria>
        }
        @if (images.length > 1) {
        <button type="button" class="hero-slide-nav hero-slide-nav--prev"
            aria-label="Previous slide"
            (click)="goToPrevHeroSlide()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.1659 8.89114H6.32912L10.8474 4.37283L9.69967 3.23315L3.2334 9.69942L9.69967 16.1657L10.8393 15.026L6.32912 10.5077H16.1659V8.89114Z"
                    fill="currentcolor" />
            </svg>
        </button>
        <button type="button" class="hero-slide-nav hero-slide-nav--next"
            aria-label="Next slide"
            (click)="goToNextHeroSlide()">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.29697e-05 5.65798H9.83689L5.31859 1.13968L6.46635 0L12.9326 6.46627L6.46635 12.9325L5.32667 11.7929L9.83689 7.27455H8.29697e-05V5.65798Z"
                    fill="currentcolor" />
            </svg>

        </button>
        }
        } @else {
        <ngx-skeleton-loader count="14" appearance="line"></ngx-skeleton-loader>
        }
        }
        @case ('seasonal-video') {
        @if (seasonalPromotionsData?.video?.media) {
        <video width="100%" id="main-video"
            class="video-playing embed-responsive-item hero-media-video"
            oncanplay="this.play()" loop muted autoplay playsinline
            onloadedmetadata="this.muted = true">
            <source id="source_mp4" [src]="seasonalPromotionsData?.video?.media"
                type="video/mp4">
        </video>
        } @else {
        <ngx-skeleton-loader count="14" appearance="line"></ngx-skeleton-loader>
        }
        }
        @default {
        @if (isBoat) {
        <img
            class="video-playing embed-responsive-item homescreen_video hero-media-video"
            height="760" width="1351"
            [src]="is_mobile_view ? 'assets/images/home_video_mobile.jpg' : 'homescreen _video1.jpg'"
            alt />
        } @else if (banner_video) {
        <video #videoElement width="100%" id="main-video"
            class="video-playing embed-responsive-item hero-media-video" loop
            muted autoplay playsinline
            oncanplay="this.play()" onloadedmetadata="this.muted = true">
            <source id="source_mp4" [src]="banner_video" type="video/mp4">
        </video>
        } @else {
        <ngx-skeleton-loader count="14" appearance="line"></ngx-skeleton-loader>
        }
        }
        }

        @if (bannerMode !== 'default' && heroSeasonalSlide?.setOverlay === 1) {
        <div class="gallery-overlay"></div>
        }
        @if (bannerMode === 'default') {
        <div class="gallery-overlay gallery-overlay--soft"></div>
        }

        <div class=" hero-overlay-copy">
            <div class="container"
                [class.hero-overlay-copy--default]="bannerMode === 'default'">
                @if (bannerMode === 'default') {
                <h1 class="hero-title hero-title--default">
                    Collect Moments,<br /> Not Things<sup>®</sup>
                </h1>
                } @else if (heroSeasonalSlide) {
                @let titleParts = splitHeroTitle(heroSeasonalSlide.heading);
                <div class="hero-title-block">
                    @if (titleParts.accent) {
                    <h1 class="hero-title">
                        <span class="hero-title-accent">{{ titleParts.accent
                            }}</span>
                        @if (titleParts.rest) {
                        <br />
                        <span class="hero-title-rest">{{ titleParts.rest
                            }}</span>
                        }
                    </h1>
                    }
                </div>
                @if (heroSeasonalSlide.subHeading) {
                <p class="hero-subtitle">{{ heroSeasonalSlide.subHeading }}</p>
                }
                @if (heroSeasonalSlide.buttonText &&
                heroSeasonalSlide.buttonUrl) {
                <a class="hero-cta" [href]="heroSeasonalSlide.buttonUrl">
                    <span class="btn-title">{{ heroSeasonalSlide.buttonText }}</span>
                    <span class="hero-cta-arrow" aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 14 14"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 7H11.5M11.5 7L7.5 3M11.5 7L7.5 11"
                                stroke="currentColor" stroke-width="1.6"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                </a>
                }
                }
            </div>
        </div>
    </div>

    <div class="hero-search-pill">
        <div class="home_searchInner search-box-width hero-search-inner">
            <div class="search_placeBox set-search-box-icon">
                <div class="location-icon hero-theme-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M10 17.5C13.75 13.75 16.25 10.75 16.25 7.5C16.25 4.04822 13.4518 1.25 10 1.25C6.54822 1.25 3.75 4.04822 3.75 7.5C3.75 10.75 6.25 13.75 10 17.5Z"
                            stroke="currentColor" stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M10 9.58333C11.1506 9.58333 12.0833 8.6506 12.0833 7.5C12.0833 6.3494 11.1506 5.41667 10 5.41667C8.8494 5.41667 7.91667 6.3494 7.91667 7.5C7.91667 8.6506 8.8494 9.58333 10 9.58333Z"
                            stroke="currentColor" stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="search-box-content w-100">
                    <label class="search_placeLable">Where To?</label>
                    <div class="input_boxSearch search_show_box">
                        <div
                            class="primeAutocomplete homeAutoCompCountryParent homeSerachWidth">
                            <p-autocomplete #autoCompleteRef
                                emptyMessage="No records found."
                                (onClear)="search_clear()"
                                [suggestions]="autocompleteExpResults"
                                (completeMethod)="autocompleteSearch($event)"
                                (onSelect)="onSelectAutocompleteSearch($event,false);"
                                field="label"
                                [autofocus]="false"
                                (pointerdown)="onSearchBoxPointerDown()"
                                (onFocus)="onFocusSearchBox($event)"
                                (onBlur)="onBlurSearchBox($event)"
                                (input)="searchedInput($event)"
                                (keydown.enter)="onEnterSearch($event)"
                                placeholder="Search for a place or experience"
                                [style]="{'width':'100%'}"
                                [inputStyle]="{'width':'100%'}"
                                id="autoCompleteSearchValue">
                                <ng-template let-country pTemplate="item">
                                    <div
                                        class="country-item homeCountyAutoComplete">
                                        <div class="location-icons-photo">
                                            @if(country?.type == 'location'){
                                            <img [src]="country?.image_url"
                                                class="flag" />
                                            }
                                            @if(country?.type == 'exp' ||
                                            country?.type == 'category'){
                                            <img
                                                [src]="(country?.type == 'exp') ? exp_image_url + country?.image : ((country?.type == 'category') ? category_image_url + country?.image : location_image_url + country?.image )"
                                                class="flag" />
                                            }
                                        </div>
                                        <div
                                            class="countryLabelHomeparent text-left">
                                            <div class="countryLabelHome">
                                                {{ country.label }}
                                                @if (country.type === 'location'
                                                && country?.state_name &&
                                                country.state_name !== '') {
                                                <span>({{ country.state_name
                                                    }})</span>
                                                }
                                            </div>
                                            @if(country.type == 'exp'){
                                            <div class="countryLabelAddress">
                                                {{country.city_name}} ,
                                                {{country.state_name}}
                                            </div>
                                            }
                                            @if(country.type == 'location'){
                                            <div class="countryLabelprice">
                                                <span>(Location)</span>
                                            </div>
                                            }
                                            @if(country.type == 'exp' &&
                                            country.experience_type == 1){
                                            <div class="countryLabelprice">
                                                ${{country?.all_in_one_price?.total_price
                                                | priceFormat}}
                                                <span>
                                                    &#123;
                                                    {{country?.all_in_one_price?.price_label}}
                                                    &#125;
                                                </span>
                                            </div>
                                            }
                                            @if(country.type == 'exp' &&
                                            country.experience_type == 2){
                                            <div class="countryLabelprice">
                                                ANY PRICE
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </ng-template>
                            </p-autocomplete>

                            @if(showRecentSearches){
                            <div class="recent-searches-dropdown">
                                <ul class="recent-head" (click)="nearby(false)">
                                    <li>
                                        <div class="recent-nearby-box">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16" height="16"
                                                viewBox="0 0 32 32" fill="none">
                                                <path
                                                    d="M28.707 3.293a.997.997 0 0 0-1.123-.202l-24 11a1 1 0 0 0 .333 1.906l11.157.93.93 11.156a1 1 0 0 0 1.906.334l11-24a1 1 0 0 0-.203-1.124zM17.68 24.117l-.683-8.2a1 1 0 0 0-.914-.914l-8.2-.683L25.97 6.03z"
                                                    fill="#E85325"></path>
                                            </svg>
                                            Search Nearby
                                        </div>

                                    </li>
                                    <li>
                                        @if(searchHistory?.length){
                                        <div class="recents-clear">
                                            <a (click)="clearRecentSearch()"
                                                href="#">Clear</a>
                                        </div>
                                        }
                                    </li>
                                </ul>
                                @if(searchHistory?.length){
                                <div class="search-reset">
                                    <div class="recents">Recent Searches</div>

                                </div>
                                <ul class="recent-result-box">
                                    @for(search of searchHistory;track search){
                                    <li class="recent-result-items"
                                        (click)="selectRecentSearch(search,false)">
                                        <div class="location-icons-photo">
                                            @if(search?.type == 'exp' ||
                                            search?.type ==
                                            'higher-level-category'){
                                            <img [src]="search.image_url"
                                                class="img-fluid search-img" />
                                            } @else {
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24" height="24"
                                                viewBox="0 0 20 20"
                                                fill="none"><path
                                                    _ngcontent-ng-c4127728709
                                                    d="M10 17.5C13.75 13.75 16.25 10.75 16.25 7.5C16.25 4.04822 13.4518 1.25 10 1.25C6.54822 1.25 3.75 4.04822 3.75 7.5C3.75 10.75 6.25 13.75 10 17.5Z"
                                                    stroke="currentColor"
                                                    stroke-width="1.66667"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"></path><path
                                                    _ngcontent-ng-c4127728709
                                                    d="M10 9.58333C11.1506 9.58333 12.0833 8.6506 12.0833 7.5C12.0833 6.3494 11.1506 5.41667 10 5.41667C8.8494 5.41667 7.91667 6.3494 7.91667 7.5C7.91667 8.6506 8.8494 9.58333 10 9.58333Z"
                                                    stroke="currentColor"
                                                    stroke-width="1.66667"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"></path></svg>
                                            }
                                        </div>
                                        <div class="location-infos">
                                            <span
                                                class="product-name">{{search.title}}</span>
                                            @if(search.city){
                                            <div class="search-city-block">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16" height="16"
                                                    viewBox="0 0 20 20"
                                                    fill="none"><path
                                                        _ngcontent-ng-c4127728709
                                                        d="M10 17.5C13.75 13.75 16.25 10.75 16.25 7.5C16.25 4.04822 13.4518 1.25 10 1.25C6.54822 1.25 3.75 4.04822 3.75 7.5C3.75 10.75 6.25 13.75 10 17.5Z"
                                                        stroke="currentColor"
                                                        stroke-width="1.66667"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"></path><path
                                                        _ngcontent-ng-c4127728709
                                                        d="M10 9.58333C11.1506 9.58333 12.0833 8.6506 12.0833 7.5C12.0833 6.3494 11.1506 5.41667 10 5.41667C8.8494 5.41667 7.91667 6.3494 7.91667 7.5C7.91667 8.6506 8.8494 9.58333 10 9.58333Z"
                                                        stroke="currentColor"
                                                        stroke-width="1.66667"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"></path></svg>
                                                <span
                                                    class="cityName mt-0">{{search.city}}</span>

                                            </div>
                                            }
                                            @if(search.location_type){
                                            <span
                                                class="cityName">(Location)</span>
                                            }
                                        </div>
                                    </li>
                                    }
                                </ul>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="hero-search-divider" aria-hidden="true"></div>
            <div class="search_placeBox set-search-box-icon">
                <div class="location-icon hero-theme-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20"
                        height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M6.66406 1.66602V4.99935" stroke="currentColor"
                            stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M13.3359 1.66602V4.99935" stroke="currentColor"
                            stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M15.8333 3.33398H4.16667C3.24619 3.33398 2.5 4.08018 2.5 5.00065V16.6673C2.5 17.5878 3.24619 18.334 4.16667 18.334H15.8333C16.7538 18.334 17.5 17.5878 17.5 16.6673V5.00065C17.5 4.08018 16.7538 3.33398 15.8333 3.33398Z"
                            stroke="currentColor" stroke-width="1.66667"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2.5 8.33398H17.5" stroke="currentColor"
                            stroke-width="1.66667" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="search-box-content w-100">
                    <label class="search_placeLable">When? (optional)</label>
                    <div class="input_boxSearch">
                        <div class="selectDataBlock">
                            <input type="text" bsDaterangepicker
                                [dateCustomClasses]="dateCustomClasses"
                                placement="bottom left" [outsideClick]="true"
                                class="date_pickerFont date_picker_label"
                                [bsConfig]="{showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY',displayMonths :1}"
                                [minDate]="minDate" [maxDate]="maxDate"
                                placeholder="Select dates"
                                (bsValueChange)="onSchedulingDateSelect($event)"
                                (onShown)="onShowPicker($event)"
                                readonly="readonly"
                                [(ngModel)]="selectedDateRange" />
                            @if(selectedDateRange?.length){
                            <a class="dataClear" (click)="clearDate()"
                                href="javascript:void(0);">
                                <svg width="10" height="10" viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.8125 3.81227C4.04691 3.57793 4.36479 3.44629 4.69625 3.44629C5.02771 3.44629 5.34559 3.57793 5.58 3.81227L10 8.23227L14.42 3.81227C14.6558 3.58457 14.9715 3.45858 15.2993 3.46143C15.627 3.46428 15.9405 3.59574 16.1723 3.8275C16.404 4.05926 16.5355 4.37277 16.5383 4.70052C16.5412 5.02827 16.4152 5.34402 16.1875 5.57977L11.7675 9.99977L16.1875 14.4198C16.4152 14.6555 16.5412 14.9713 16.5383 15.299C16.5355 15.6268 16.404 15.9403 16.1723 16.172C15.9405 16.4038 15.627 16.5353 15.2993 16.5381C14.9715 16.541 14.6558 16.415 14.42 16.1873L10 11.7673L5.58 16.1873C5.34425 16.415 5.02849 16.541 4.70075 16.5381C4.373 16.5353 4.05949 16.4038 3.82773 16.172C3.59597 15.9403 3.46451 15.6268 3.46166 15.299C3.45881 14.9713 3.5848 14.6555 3.8125 14.4198L8.2325 9.99977L3.8125 5.57977C3.57816 5.34536 3.44652 5.02748 3.44652 4.69602C3.44652 4.36457 3.57816 4.04668 3.8125 3.81227Z"
                                        fill="#25324B" />
                                </svg>
                            </a>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="search_homeBtn">
                <button type="button"
                    class="primeSeachBox prime_active hero-search-btn"
                    (click)="onSelectAutocompleteExperience(autocomplete_search_to,true, false)"
                    aria-label="Search">
                    <span class="search-text">Search</span>
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M31.0044 0H0V31.0044H31.0044V0Z"
                            fill="#E85325" />
                        <path
                            d="M14.0493 24.2226C19.6679 24.2226 24.2226 19.6679 24.2226 14.0493C24.2226 8.43073 19.6679 3.87598 14.0493 3.87598C8.43073 3.87598 3.87598 8.43073 3.87598 14.0493C3.87598 19.6679 8.43073 24.2226 14.0493 24.2226Z"
                            fill="#E85325" stroke="white" stroke-width="2.22485"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M21.2432 21.2437L27.1292 27.1297"
                            stroke="white" stroke-width="2.22485"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </button>
            </div>
        </div>
    </div>
</section>

<section class="hero-features-new" aria-label="Why Spur">
    <div class="container">
        <div class="hero-features-card">
            @for (feature of heroFeatures; track feature.title) {
            <div class="hero-feature-item">
                <div class="hero-feature-icon" [attr.data-icon]="feature.icon">
                    @switch (feature.icon) {
                    @case ('cash') {
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5530_1298)">
                            <path
                                d="M23.6221 6.49423H23.2986V3.35257C23.2986 2.04139 22.2318 0.974609 20.9206 0.974609H3.67318C1.76991 0.974609 0.200667 2.43039 0.0195182 4.28685C-0.00814679 4.41803 0.00170438 3.24916 0.00170438 21.3535C0.00170438 23.378 1.64869 25.0249 3.67313 25.0249H23.622C24.9332 25.0249 26 23.9582 26 22.647V8.87219C26 7.56101 24.9333 6.49423 23.6221 6.49423ZM3.67318 2.60802H20.9206C21.3312 2.60802 21.6652 2.94204 21.6652 3.35262V6.49428H3.67318C2.58123 6.49428 1.68733 5.631 1.63751 4.55115C1.68728 3.47124 2.58118 2.60802 3.67318 2.60802ZM23.6221 23.3916H3.67318C2.54938 23.3916 1.63511 22.4773 1.63511 21.3535V7.50864C2.21858 7.89947 2.91969 8.12758 3.67318 8.12758H23.6221C24.0326 8.12758 24.3667 8.4616 24.3667 8.87219V12.1831H18.2208C16.1277 12.1831 14.4248 13.8859 14.4248 15.979C14.4248 18.0721 16.1277 19.7749 18.2208 19.7749H24.3667V22.647C24.3667 23.0576 24.0326 23.3916 23.6221 23.3916ZM24.3667 18.1416H18.2208C17.0283 18.1416 16.0581 17.1715 16.0581 15.9791C16.0581 14.7866 17.0283 13.8165 18.2208 13.8165H24.3667V18.1416Z"
                                fill="#E85325" />
                            <path
                                d="M18.5224 17.163C19.1761 17.163 19.706 16.6331 19.706 15.9795C19.706 15.3258 19.1761 14.7959 18.5224 14.7959C17.8688 14.7959 17.3389 15.3258 17.3389 15.9795C17.3389 16.6331 17.8688 17.163 18.5224 17.163Z"
                                fill="#E85325" />
                        </g>
                        <defs>
                            <clippath id="clip0_5530_1298">
                                <rect width="26" height="26" fill="white" />
                            </clippath>
                        </defs>
                    </svg>
                    }
                    @case ('swap') {
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M25.1183 20.3818C25.2822 20.5459 25.3742 20.7683 25.3742 21.0001C25.3742 21.232 25.2822 21.4544 25.1183 21.6185L21.6183 25.1185C21.4543 25.2823 21.2319 25.3744 21 25.3744C20.7681 25.3744 20.5457 25.2823 20.3817 25.1185C20.2178 24.9544 20.1258 24.732 20.1258 24.5001C20.1258 24.2683 20.2178 24.0459 20.3817 23.8818L22.3883 21.8751H5.25C4.55381 21.8751 3.88613 21.5986 3.39384 21.1063C2.90156 20.614 2.625 19.9463 2.625 19.2501V14.0001C2.625 13.7681 2.71719 13.5455 2.88128 13.3814C3.04538 13.2173 3.26794 13.1251 3.5 13.1251C3.73206 13.1251 3.95462 13.2173 4.11872 13.3814C4.28281 13.5455 4.375 13.7681 4.375 14.0001V19.2501C4.37802 19.4813 4.47118 19.7021 4.63462 19.8655C4.79807 20.029 5.01888 20.1221 5.25 20.1251H22.3883L20.3817 18.1185C20.2271 17.9526 20.143 17.7332 20.147 17.5065C20.151 17.2799 20.2428 17.0636 20.4031 16.9033C20.5634 16.7429 20.7797 16.6511 21.0064 16.6471C21.2331 16.6431 21.4525 16.7273 21.6183 16.8818L25.1183 20.3818ZM22.785 6.12515H5.61167L7.61833 4.11848C7.77289 3.95261 7.85704 3.73322 7.85304 3.50654C7.84904 3.27985 7.75721 3.06357 7.59689 2.90325C7.43658 2.74294 7.22029 2.65111 6.99361 2.64711C6.76692 2.64311 6.54754 2.72725 6.38167 2.88181L2.88167 6.38181C2.71781 6.54588 2.62577 6.76827 2.62577 7.00015C2.62577 7.23202 2.71781 7.45442 2.88167 7.61848L6.38167 11.1185C6.54573 11.2823 6.76812 11.3744 7 11.3744C7.23188 11.3744 7.45427 11.2823 7.61833 11.1185C7.78219 10.9544 7.87423 10.732 7.87423 10.5001C7.87423 10.2683 7.78219 10.0459 7.61833 9.88181L5.61167 7.87515H22.75C22.9811 7.87817 23.2019 7.97133 23.3654 8.13477C23.5288 8.29821 23.622 8.51902 23.625 8.75015V14.0001C23.625 14.2322 23.7172 14.4548 23.8813 14.6189C24.0454 14.783 24.2679 14.8751 24.5 14.8751C24.7321 14.8751 24.9546 14.783 25.1187 14.6189C25.2828 14.4548 25.375 14.2322 25.375 14.0001V8.75015C25.375 8.05395 25.0984 7.38627 24.6062 6.89399C24.1139 6.40171 23.4462 6.12515 22.75 6.12515H22.785Z"
                            fill="#E85325" />
                    </svg>
                    }
                    @case ('calendar') {
                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M29.1651 8.95744C29.0021 6.24783 26.7396 4.125 24.0145 4.125H22.6878V3.09375C22.6878 2.5245 22.2258 2.0625 21.6565 2.0625C21.0873 2.0625 20.6253 2.5245 20.6253 3.09375V4.125H12.3753V3.09375C12.3753 2.5245 11.9133 2.0625 11.344 2.0625C10.7748 2.0625 10.3128 2.5245 10.3128 3.09375V4.125H8.98608C6.26048 4.125 3.99792 6.24783 3.8355 8.95744C3.52973 14.0539 3.53541 19.2235 3.85251 24.3225C4.01339 26.912 6.08775 28.9864 8.67722 29.1472C11.2724 29.3086 13.8861 29.3891 16.4998 29.3891C19.113 29.3891 21.7272 29.3086 24.3223 29.1472C26.9118 28.9864 28.9861 26.912 29.147 24.3225C29.4646 19.2261 29.4703 14.057 29.1651 8.95744ZM27.0892 24.1947C26.9922 25.7483 25.748 26.9925 24.195 27.0889C19.0892 27.406 13.9113 27.406 8.80561 27.0889C7.25203 26.9919 6.00783 25.7477 5.91141 24.1947C5.66751 20.2744 5.6175 16.3128 5.74795 12.375H27.2531C27.3831 16.3144 27.333 20.2759 27.0892 24.1947ZM11.344 8.25C11.9133 8.25 12.3753 7.788 12.3753 7.21875V6.1875H20.6253V7.21875C20.6253 7.788 21.0873 8.25 21.6565 8.25C22.2258 8.25 22.6878 7.788 22.6878 7.21875V6.1875H24.0145C25.6506 6.1875 27.0087 7.45852 27.1062 9.08067C27.1304 9.49008 27.1407 9.90206 27.1608 10.3125H5.83973C5.86036 9.90206 5.87016 9.49008 5.89439 9.08067C5.99184 7.45852 7.34948 6.1875 8.98608 6.1875H10.3128V7.21875C10.3128 7.788 10.7748 8.25 11.344 8.25Z"
                            fill="#E85325" />
                        <path
                            d="M11.3438 18.5625C12.1981 18.5625 12.8906 17.8699 12.8906 17.0156C12.8906 16.1613 12.1981 15.4688 11.3438 15.4688C10.4894 15.4688 9.79688 16.1613 9.79688 17.0156C9.79688 17.8699 10.4894 18.5625 11.3438 18.5625Z"
                            fill="#E85325" />
                        <path
                            d="M16.5 18.5625C17.3543 18.5625 18.0469 17.8699 18.0469 17.0156C18.0469 16.1613 17.3543 15.4688 16.5 15.4688C15.6457 15.4688 14.9531 16.1613 14.9531 17.0156C14.9531 17.8699 15.6457 18.5625 16.5 18.5625Z"
                            fill="#E85325" />
                        <path
                            d="M11.3438 23.7188C12.1981 23.7188 12.8906 23.0262 12.8906 22.1719C12.8906 21.3176 12.1981 20.625 11.3438 20.625C10.4894 20.625 9.79688 21.3176 9.79688 22.1719C9.79688 23.0262 10.4894 23.7188 11.3438 23.7188Z"
                            fill="#E85325" />
                        <path
                            d="M21.6562 18.5625C22.5106 18.5625 23.2031 17.8699 23.2031 17.0156C23.2031 16.1613 22.5106 15.4688 21.6562 15.4688C20.8019 15.4688 20.1094 16.1613 20.1094 17.0156C20.1094 17.8699 20.8019 18.5625 21.6562 18.5625Z"
                            fill="#E85325" />
                        <path
                            d="M21.6562 23.7188C22.5106 23.7188 23.2031 23.0262 23.2031 22.1719C23.2031 21.3176 22.5106 20.625 21.6562 20.625C20.8019 20.625 20.1094 21.3176 20.1094 22.1719C20.1094 23.0262 20.8019 23.7188 21.6562 23.7188Z"
                            fill="#E85325" />
                        <path
                            d="M16.5 23.7188C17.3543 23.7188 18.0469 23.0262 18.0469 22.1719C18.0469 21.3176 17.3543 20.625 16.5 20.625C15.6457 20.625 14.9531 21.3176 14.9531 22.1719C14.9531 23.0262 15.6457 23.7188 16.5 23.7188Z"
                            fill="#E85325" />
                    </svg>
                    }
                    @case ('gift') {
                    <svg width="30" height="29" viewBox="0 0 30 29" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5530_1317)">
                            <path
                                d="M27.3633 4.30469H2.63672C1.18283 4.30469 0 5.44809 0 6.85352V22.1465C0 23.5519 1.18283 24.6953 2.63672 24.6953H27.3633C28.8172 24.6953 30 23.5519 30 22.1465V6.85352C30 5.44809 28.8172 4.30469 27.3633 4.30469ZM8.78906 22.9961H2.63672C2.15209 22.9961 1.75781 22.615 1.75781 22.1465V12.8008H3.65947C4.09799 14.0665 5.44236 14.8289 6.80502 14.5708L5.42103 16.5776C5.1518 16.968 5.26096 17.4955 5.66484 17.7558C6.06867 18.016 6.61441 17.9105 6.88365 17.5201L8.78906 14.7573V22.9961ZM5.27344 11.95C5.27344 11.1765 6.16336 10.7136 6.83115 11.1441L8.08348 11.9512L6.83115 12.7582C6.16564 13.1871 5.27344 12.7293 5.27344 11.95ZM8.78906 10.3636L7.80621 9.73024C6.28881 8.75234 4.23416 9.44329 3.65977 11.1015H1.75781V6.85346C1.75781 6.38504 2.15209 6.00391 2.63672 6.00391H8.78906V10.3636ZM28.2422 22.1465C28.2422 22.615 27.8479 22.9961 27.3633 22.9961H10.5469V14.7573L12.4523 17.5201C12.7219 17.911 13.2677 18.0158 13.6711 17.7558C14.075 17.4955 14.1841 16.968 13.9149 16.5776L12.5309 14.5709C13.8874 14.8277 15.2357 14.0725 15.6762 12.8008H28.2422V22.1465ZM11.2525 11.9512L12.5048 11.1441C13.1704 10.7152 14.0625 11.173 14.0625 11.9523C14.0625 12.7271 13.1713 13.1879 12.5048 12.7582L11.2525 11.9512ZM28.2422 11.1016H15.6765C15.102 9.44352 13.0473 8.75228 11.5297 9.73029L10.5469 10.3636V6.00391H27.3633C27.8479 6.00391 28.2422 6.38504 28.2422 6.85352V11.1016Z"
                                fill="#E85325" />
                            <path
                                d="M25.6055 16.1992H18.457C17.9716 16.1992 17.5781 16.5796 17.5781 17.0488C17.5781 17.518 17.9716 17.8984 18.457 17.8984H25.6055C26.0909 17.8984 26.4844 17.518 26.4844 17.0488C26.4844 16.5796 26.0909 16.1992 25.6055 16.1992Z"
                                fill="#E85325" />
                            <path
                                d="M25.6055 19.5977H18.457C17.9716 19.5977 17.5781 19.9781 17.5781 20.4473C17.5781 20.9165 17.9716 21.2969 18.457 21.2969H25.6055C26.0909 21.2969 26.4844 20.9165 26.4844 20.4473C26.4844 19.9781 26.0909 19.5977 25.6055 19.5977Z"
                                fill="#E85325" />
                        </g>
                        <defs>
                            <clippath id="clip0_5530_1317">
                                <rect width="30" height="29" fill="white" />
                            </clippath>
                        </defs>
                    </svg>
                    }
                    }
                </div>
                <div class="hero-feature-copy">
                    <h3 class="hero-feature-title">{{ feature.title }}</h3>
                    <p class="hero-feature-desc">{{ feature.description }}</p>
                </div>
            </div>
            }
        </div>
    </div>
</section>

@if (showPlanningNearbySection) {
<section class="planning-nearby-section"
    aria-label="Nearby and continue planning experiences">
    <div class="container">
        <div class="planning-nearby-row"
            [class.planning-nearby-row--both]="planningNearbyIsBoth">
            @if (hasNearbyExperiences) {
            <div class="planning-nearby-col planning-nearby-col--nearby"
                [style.--pn-slots]="nearbyCardSlots"
                [style.--pn-count]="nearbyExperiencesPreview.length">
                <div class="planning-nearby-head">
                    <div class="planning-nearby-titles">
                        <p class="sub-text">Where to Go</p>
                        <h2 class="section-title">Nearby You</h2>
                    </div>
                    @if (showNearbyBrowseAll) {
                    <ng-container *ngTemplateOutlet="pnBrowseAll"></ng-container>
                    }
                </div>

                @if (planningNearbyMode === 'mobile') {
                <swiper-container class="custom-swiper pn-swiper"
                    slides-per-view="auto"
                    space-between="12"
                    [attr.loop]="nearbyExperiencesPreview.length > 2 ? 'true' : 'false'"
                    [autoplay]="nearbyExperiencesPreview.length > 2 ? { delay: 3000, disableOnInteraction: false } : false">
                    @for (record of nearbyExperiencesPreview; track
                    trackPlanningNearbyItem(record, $index)) {
                    <swiper-slide>
                        <ng-container
                            *ngTemplateOutlet="pnNearbyCard; context: { $implicit: record }"></ng-container>
                    </swiper-slide>
                    }
                </swiper-container>
                } @else {
                <div class="planning-nearby-cards">
                    @for (record of nearbyExperiencesPreview; track
                    trackPlanningNearbyItem(record, $index)) {
                    <ng-container
                        *ngTemplateOutlet="pnNearbyCard; context: { $implicit: record }"></ng-container>
                    }
                </div>
                }
            </div>
            }

            @if (hasContinuePlanning) {
            <div class="planning-nearby-col planning-nearby-col--continue"
                [style.--pn-slots]="continueCardSlots"
                [style.--pn-count]="continuePlanningPreview.length">
                <div class="planning-nearby-head">
                    <div class="planning-nearby-titles">
                        <p class="sub-text">Plan your perfect trip</p>
                        <h2 class="section-title">Continue Planning</h2>
                    </div>
                </div>

                @if (planningNearbyMode === 'mobile') {
                <swiper-container class="custom-swiper pn-swiper"
                    slides-per-view="auto"
                    space-between="12"
                    [attr.loop]="continuePlanningPreview.length > 2 ? 'true' : 'false'"
                    [autoplay]="continuePlanningPreview.length > 2 ? { delay: 3000, disableOnInteraction: false } : false">
                    @for (search of continuePlanningPreview; track
                    trackPlanningNearbyItem(search, $index)) {
                    <swiper-slide>
                        <ng-container
                            *ngTemplateOutlet="pnContinueCard; context: { $implicit: search }"></ng-container>
                    </swiper-slide>
                    }
                </swiper-container>
                } @else {
                <div class="planning-nearby-cards">
                    @for (search of continuePlanningPreview; track
                    trackPlanningNearbyItem(search, $index)) {
                    <ng-container
                        *ngTemplateOutlet="pnContinueCard; context: { $implicit: search }"></ng-container>
                    }
                </div>
                }
            </div>
            }
        </div>
    </div>
</section>

<ng-template #pnBrowseAll>
    <a class="planning-nearby-browse"
        href="javascript:void(0)"
        (click)="onBrowseNearbyShop($event)">
        <span>Browse All</span>
        <span class="planning-nearby-browse-arrow" aria-hidden="true">
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                <path d="M2.5 7H11.5M11.5 7L7.5 3M11.5 7L7.5 11"
                    stroke="#E85325" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </span>
    </a>
</ng-template>

<ng-template #pnPinIcon>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.9408 12.253H8.23521C8.68965 11.8471 9.11826 11.4132 9.51851 10.9538C11.0201 9.22686 11.816 7.40639 11.816 5.68875C11.816 4.41207 11.3088 3.18767 10.4061 2.28492C9.50331 1.38216 8.27892 0.875 7.00223 0.875C5.72554 0.875 4.50115 1.38216 3.59839 2.28492C2.69564 3.18767 2.18848 4.41207 2.18848 5.68875C2.18848 7.40639 2.9822 9.22686 4.48595 10.9538C4.8862 11.4132 5.3148 11.8471 5.76925 12.253H3.0637C2.94764 12.253 2.83633 12.2991 2.75426 12.3811C2.6722 12.4632 2.62609 12.5745 2.62609 12.6906C2.62609 12.8066 2.6722 12.9179 2.75426 13C2.83633 13.0821 2.94764 13.1282 3.0637 13.1282H10.9408C11.0568 13.1282 11.1681 13.0821 11.2502 13C11.3323 12.9179 11.3784 12.8066 11.3784 12.6906C11.3784 12.5745 11.3323 12.4632 11.2502 12.3811C11.1681 12.2991 11.0568 12.253 10.9408 12.253ZM3.0637 5.68875C3.0637 4.64419 3.47865 3.64241 4.21727 2.9038C4.95589 2.16518 5.95767 1.75023 7.00223 1.75023C8.04679 1.75023 9.04857 2.16518 9.78719 2.9038C10.5258 3.64241 10.9408 4.64419 10.9408 5.68875C10.9408 8.81933 7.90645 11.4324 7.00223 12.1436C6.09801 11.4324 3.0637 8.81933 3.0637 5.68875ZM9.1903 5.68875C9.1903 5.25599 9.06197 4.83295 8.82154 4.47313C8.58112 4.1133 8.23939 3.83285 7.83957 3.66724C7.43975 3.50163 6.9998 3.4583 6.57536 3.54273C6.15091 3.62715 5.76104 3.83555 5.45503 4.14155C5.14902 4.44756 4.94063 4.83744 4.8562 5.26188C4.77178 5.68633 4.81511 6.12627 4.98072 6.52609C5.14633 6.92591 5.42678 7.26764 5.7866 7.50807C6.14643 7.7485 6.56947 7.87682 7.00223 7.87682C7.58254 7.87682 8.13909 7.6463 8.54943 7.23595C8.95977 6.82561 9.1903 6.26907 9.1903 5.68875ZM5.68939 5.68875C5.68939 5.4291 5.76639 5.17527 5.91064 4.95938C6.0549 4.74348 6.25994 4.57521 6.49983 4.47585C6.73972 4.37648 7.00369 4.35048 7.25835 4.40114C7.51302 4.45179 7.74694 4.57683 7.93055 4.76043C8.11415 4.94404 8.23919 5.17796 8.28985 5.43263C8.3405 5.6873 8.3145 5.95127 8.21514 6.19116C8.11577 6.43105 7.9475 6.63608 7.73161 6.78034C7.51571 6.9246 7.26189 7.0016 7.00223 7.0016C6.65404 7.0016 6.32012 6.86328 6.07391 6.61707C5.8277 6.37087 5.68939 6.03694 5.68939 5.68875Z"
            fill="#E85325" />
    </svg>
</ng-template>

<ng-template #pnNearbyCard let-record>
    <a class="pn-card" [routerLink]="['/experiences', record.slug]">
        <div class="pn-card-media">
            <img [src]="getExperienceCardImage(record)"
                [alt]="record.alt_text_image || record.title || 'Experience'"
                class="pn-card-image"
                loading="lazy" width="360" height="160"
                (error)="onExperienceImageError($event)" />
        </div>
        <div class="pn-card-body">
            <h3 class="pn-card-title">{{ record.title }}</h3>
            <p class="pn-card-location">
                <ng-container *ngTemplateOutlet="pnPinIcon"></ng-container>
                <span>{{ record?.city || 'Nearby' }}</span>
            </p>
            <div class="pn-card-price-row">
                @if (!(record?.exp_price > 0) &&
                !(record?.all_in_one_price?.exp_price > 0)) {
                <span class="pn-card-price-label">View Price Options</span>
                } @else {
                <span class="pn-card-price-label">{{
                    record?.price_label ||
                    record?.all_in_one_price?.price_label ||
                    'Per Person' }}</span>
                <span class="pn-card-price">${{
                    (record?.exp_price ||
                    record?.all_in_one_price?.exp_price) |
                    priceFormat }}</span>
                }
            </div>
        </div>
    </a>
</ng-template>

<ng-template #pnContinueCard let-search>
    <a class="pn-card" [routerLink]="['/experiences', search.params]">
        <div class="pn-card-media">
            <img [src]="getExperienceCardImage(search)"
                [alt]="search.title || 'Experience'"
                class="pn-card-image"
                loading="lazy" width="360" height="160"
                (error)="onExperienceImageError($event)" />
        </div>
        <div class="pn-card-body">
            <h3 class="pn-card-title">{{ search.title }}</h3>
            @if (getExperienceLocation(search)) {
            <p class="pn-card-location">
                <ng-container *ngTemplateOutlet="pnPinIcon"></ng-container>
                <span>{{ getExperienceLocation(search) }}</span>
            </p>
            }
            <div class="pn-card-price-row">
                @if (search?.price === 0) {
                <span class="pn-card-price-label">Any Price</span>
                } @else {
                <span class="pn-card-price-label">{{
                    search?.price_label || 'Per Person' }}</span>
                @if (search?.price) {
                <span class="pn-card-price">${{ search.price |
                    priceFormat }}</span>
                }
                }
            </div>
        </div>
    </a>
</ng-template>
}


<section class="popular-section">
    <div class="container">
        <div class="pd-head">
            <div class="pd-titles">
                <p class="sub-text">Top Rated Getaways</p>
                <h2 class="section-title">Popular Destinations</h2>
            </div>
            <button type="button" class="planning-nearby-browse"
                [routerLink]="['/locations']">
                <span>Browse All</span>
                <span class="pd-browse-arrow" aria-hidden="true">
                    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                        <path d="M2.5 7H11.5M11.5 7L7.5 3M11.5 7L7.5 11"
                            stroke="currentColor" stroke-width="1.6"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </button>
        </div>

        <div class="pd-slider-wrap">
            <button type="button" class="pd-nav pd-nav--prev"
                (click)="slidePrev('swiperEl')"
                aria-label="Previous destinations">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.1659 8.89114H6.32912L10.8474 4.37283L9.69967 3.23315L3.2334 9.69942L9.69967 16.1657L10.8393 15.026L6.32912 10.5077H16.1659V8.89114Z"
                        fill="currentColor" />
                </svg>

            </button>
            <button type="button" class="pd-nav pd-nav--next"
                (click)="slideNext('swiperEl')"
                aria-label="Next destinations">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.23287 8.89114H13.0697L8.55137 4.37283L9.69914 3.23315L16.1654 9.69942L9.69914 16.1657L8.55946 15.026L13.0697 10.5077H3.23287V8.89114Z"
                        fill="currentColor" />
                </svg>

            </button>

            <swiper-container #swiperEl loop="true" [autoplay]="false"
                autoplay-delay="3000"
                autoplay-disable-on-interaction="false"
                [breakpoints]="popularDestinationsBreakpoints"
                class="custom-swiper pd-swiper">
                <swiper-slide class="swiper-color"
                    *ngFor="let record of popularDestinations"
                    (mouseenter)="pauseSwiper('swiperEl')"
                    (mouseleave)="resumeSwiper('swiperEl')">
                    <a [routerLink]="['/location-region', record?.slug]"
                        class="pd-card">
                        <img class="pd-card-image"
                            [src]="record?.image_url ? record.image_url + '?width=360' : defaultExperienceImage"
                            [alt]="record?.name || 'Destination'" loading="lazy"
                            width="280" height="250"
                            (error)="onExperienceImageError($event)" />
                        <div class="pd-card-content">
                            @if (getDestinationPlacesLabel(record); as
                            placesLabel) {
                            @if(placesLabel.trim() !== '') {
                            <div class="pd-card-meta">
                                <svg width="11" height="15" viewBox="0 0 11 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10.1402 5.12642C10.1402 4.45321 10.009 3.78659 9.75423 3.16462C9.49944 2.54266 9.12598 1.97753 8.65518 1.50149C8.18438 1.02546 7.62545 0.647852 7.01032 0.390225C6.39519 0.132599 5.7359 0 5.07009 0C4.40427 0 3.74498 0.132599 3.12985 0.390225C2.51472 0.647852 1.95579 1.02546 1.48499 1.50149C1.01419 1.97753 0.640733 2.54266 0.385937 3.16462C0.131142 3.78659 -9.92139e-09 4.45321 0 5.12642C0 6.14218 0.296962 7.08691 0.800349 7.8837H0.794555C2.5039 10.5897 5.07009 14.6469 5.07009 14.6469L9.34562 7.8837H9.34055C9.86234 7.06082 10.1398 6.10391 10.1402 5.12642ZM5.07009 7.32346C4.4938 7.32346 3.94111 7.09198 3.53362 6.67996C3.12612 6.26794 2.89719 5.70911 2.89719 5.12642C2.89719 4.54373 3.12612 3.9849 3.53362 3.57288C3.94111 3.16086 4.4938 2.92938 5.07009 2.92938C5.64637 2.92938 6.19906 3.16086 6.60655 3.57288C7.01405 3.9849 7.24298 4.54373 7.24298 5.12642C7.24298 5.70911 7.01405 6.26794 6.60655 6.67996C6.19906 7.09198 5.64637 7.32346 5.07009 7.32346Z"
                                        fill="#fff" />
                                </svg>

                                <span>{{ placesLabel }}</span>
                            </div>
                            }
                            }
                            <h3 class="pd-card-name">{{ record?.name }}</h3>
                        </div>
                    </a>
                </swiper-slide>
            </swiper-container>
        </div>
    </div>
</section>




<section class="popular-categories-section">
    <div class="container">
        <div class="pc-head">
            <div class="pc-titles">
                <p class="sub-text">Find Your Perfect Experiences</p>
                <h2 class="section-title">Popular Categories</h2>
            </div>
            <button type="button" class="planning-nearby-browse"
                [routerLink]="['/experience']">
                <span>Browse All</span>
                <span class="pc-browse-arrow" aria-hidden="true">
                    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                        <path d="M2.5 7H11.5M11.5 7L7.5 3M11.5 7L7.5 11"
                            stroke="currentColor" stroke-width="1.6"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </button>
        </div>

        <div class="pc-slider-wrap">
            <button type="button" class="pc-nav pc-nav--prev"
                (click)="slidePrev('swiperEl2')"
                aria-label="Previous categories">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.1659 8.89114H6.32912L10.8474 4.37283L9.69967 3.23315L3.2334 9.69942L9.69967 16.1657L10.8393 15.026L6.32912 10.5077H16.1659V8.89114Z"
                        fill="currentColor" />
                </svg>

            </button>
            <button type="button" class="pc-nav pc-nav--next"
                (click)="slideNext('swiperEl2')"
                aria-label="Next categories">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.23287 8.89114H13.0697L8.55137 4.37283L9.69914 3.23315L16.1654 9.69942L9.69914 16.1657L8.55946 15.026L13.0697 10.5077H3.23287V8.89114Z"
                        fill="currentColor" />
                </svg>

            </button>

            <swiper-container #swiperEl2 loop="true" [autoplay]="false"
                autoplay-delay="3000"
                autoplay-disable-on-interaction="false"
                [breakpoints]="popularDestinationsBreakpoints"
                class="custom-swiper pc-swiper">
                <swiper-slide class="swiper-color"
                    *ngFor="let higherCategory of popularCategories"
                    (mouseenter)="pauseSwiper('swiperEl2')"
                    (mouseleave)="resumeSwiper('swiperEl2')">
                    <a class="pc-card"
                        [routerLink]="['/experience', higherCategory.slug]">
                        <div class="pc-card-media">
                            <img class="pc-card-image"
                                [src]="categoryCardImage(higherCategory?.image_url)"
                                [alt]="higherCategory?.h1_tag || higherCategory?.name || 'Category'"
                                loading="lazy"
                                fetchpriority="low"
                                width="280" height="180"
                                (error)="onExperienceImageError($event)" />
                        </div>
                        <div class="pc-card-body">
                            <h3 class="pc-card-title">{{ higherCategory?.name
                                }}</h3>
                            @if (getCategorySubtitle(higherCategory); as
                            subtitle) {
                            <p class="pc-card-subtitle">{{ subtitle }}</p>
                            }
                        </div>
                    </a>
                </swiper-slide>
            </swiper-container>
        </div>
    </div>
</section>



@if (popularExperiences?.length > 0) {
<section class="trending-experiences-section"
    [style.background-image]="'url(assets/images/experience_section_bg.webp)'">
    <div class="container">
        <div class="te-head">
            <div class="te-titles">
                <p class="sub-text">Discover Unforgettable Travel Moments</p>
                <h2 class="section-title">Trending Experiences</h2>
            </div>
        </div>

        <div class="te-slider-wrap">
            <button type="button" class="te-nav te-nav--prev"
                (click)="slidePrev('swiperEl4')"
                aria-label="Previous experiences">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.1659 8.89114H6.32912L10.8474 4.37283L9.69967 3.23315L3.2334 9.69942L9.69967 16.1657L10.8393 15.026L6.32912 10.5077H16.1659V8.89114Z"
                        fill="currentColor" />
                </svg>

            </button>
            <button type="button" class="te-nav te-nav--next"
                (click)="slideNext('swiperEl4')"
                aria-label="Next experiences">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.23287 8.89114H13.0697L8.55137 4.37283L9.69914 3.23315L16.1654 9.69942L9.69914 16.1657L8.55946 15.026L13.0697 10.5077H3.23287V8.89114Z"
                        fill="currentColor" />
                </svg>
            </button>

            @if (trendingSwiperVisible) {
            <swiper-container #swiperEl4 init="false" loop="true"
                [autoplay]="false"
                autoplay-delay="3000"
                autoplay-disable-on-interaction="false"
                observer="true"
                observe-slide-children="true"
                [breakpoints]="trendingExperiencesBreakpoints"
                class="custom-swiper te-swiper">
                @for (exp of popularExperiences; track exp?.id || exp?.slug || $index) {
                <swiper-slide class="swiper-color"
                    (mouseenter)="pauseSwiper('swiperEl4')"
                    (mouseleave)="resumeSwiper('swiperEl4')">
                    <a class="te-card"
                        [routerLink]="['/experiences', exp.slug]">
                        <div class="te-card-media">
                            <img class="te-card-image"
                                [src]="getExperienceCardImage(exp)"
                                [alt]="exp?.title || 'Experience'"
                                loading="lazy" width="280" height="180"
                                (error)="onExperienceImageError($event)" />
                                
                            <!-- <button type="button" class="te-favorite"
                                aria-label="Save experience">
                                <svg width="20" height="20" viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M18.6461 2.21826C16.4328 2.21826 14.4135 3.30978 13.1885 5.05621C12.5734 4.17989 11.7563 3.46453 10.8064 2.97057C9.85649 2.47661 8.80162 2.21857 7.73095 2.21826C6.41212 2.21956 5.12324 2.61156 4.02702 3.34477C2.9308 4.07798 2.07639 5.11954 1.57163 6.33795C1.06688 7.55636 0.934425 8.897 1.19099 10.1906C1.44755 11.4843 2.08162 12.6729 3.01316 13.6064L13.1885 23.7818L23.3639 13.6064C24.2955 12.6729 24.9295 11.4843 25.1861 10.1906C25.4427 8.897 25.3102 7.55636 24.8054 6.33795C24.3007 5.11954 23.4463 4.07798 22.3501 3.34477C21.2538 2.61156 19.965 2.21956 18.6461 2.21826ZM22.0783 12.3209L13.1885 21.2107L4.29873 12.3209C3.84675 11.8712 3.48857 11.3363 3.24499 10.7471C3.0014 10.1579 2.87726 9.5262 2.87975 8.88865C2.87975 6.21443 5.05673 4.03746 7.73095 4.03746C9.81696 4.03746 11.6604 5.36547 12.3275 7.34233C12.3874 7.5233 12.5029 7.68077 12.6575 7.79237C12.8121 7.90397 12.9979 7.96404 13.1885 7.96404C13.3792 7.96404 13.565 7.90397 13.7196 7.79237C13.8741 7.68077 13.9896 7.5233 14.0496 7.34233C14.3734 6.37962 14.9911 5.5428 15.8158 4.94987C16.6405 4.35694 17.6304 4.0378 18.6461 4.03746C21.3204 4.03746 23.4973 6.21443 23.4973 8.88865C23.4973 10.1863 22.994 11.4052 22.0783 12.3209Z"
                                        fill="#EB5B2B" />
                                </svg>
                            </button> -->
                        </div>
                        <div class="te-card-body">
                            <h3 class="te-card-title">{{ exp?.title }}</h3>
                            @if (getTrendingLocation(exp); as locationLabel) {
                            <p class="te-card-location">
                                <svg width="19" height="19" viewBox="0 0 19 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M14.8438 16.625H11.1729C11.7895 16.0743 12.371 15.4856 12.9141 14.8623C14.9514 12.5192 16.0312 10.0492 16.0312 7.71875C16.0312 5.98656 15.3431 4.32531 14.1183 3.10046C12.8934 1.87561 11.2322 1.1875 9.5 1.1875C7.7678 1.1875 6.10656 1.87561 4.88171 3.10046C3.65686 4.32531 2.96875 5.98656 2.96875 7.71875C2.96875 10.0492 4.04566 12.5192 6.08594 14.8623C6.62899 15.4856 7.21052 16.0743 7.82711 16.625H4.15625C3.99878 16.625 3.84776 16.6876 3.73641 16.7989C3.62506 16.9103 3.5625 17.0613 3.5625 17.2188C3.5625 17.3762 3.62506 17.5272 3.73641 17.6386C3.84776 17.7499 3.99878 17.8125 4.15625 17.8125H14.8438C15.0012 17.8125 15.1522 17.7499 15.2636 17.6386C15.3749 17.5272 15.4375 17.3762 15.4375 17.2188C15.4375 17.0613 15.3749 16.9103 15.2636 16.7989C15.1522 16.6876 15.0012 16.625 14.8438 16.625ZM4.15625 7.71875C4.15625 6.3015 4.71925 4.9423 5.7214 3.94015C6.72355 2.938 8.08275 2.375 9.5 2.375C10.9173 2.375 12.2765 2.938 13.2786 3.94015C14.2807 4.9423 14.8438 6.3015 14.8438 7.71875C14.8438 11.9663 10.7268 15.5117 9.5 16.4766C8.27316 15.5117 4.15625 11.9663 4.15625 7.71875ZM12.4688 7.71875C12.4688 7.13159 12.2946 6.55761 11.9684 6.0694C11.6422 5.58119 11.1786 5.20068 10.6361 4.97598C10.0936 4.75129 9.49671 4.69249 8.92083 4.80704C8.34494 4.92159 7.81596 5.20434 7.40078 5.61953C6.98559 6.03471 6.70284 6.5637 6.58829 7.13958C6.47374 7.71546 6.53253 8.31237 6.75723 8.85484C6.98193 9.39731 7.36244 9.86097 7.85065 10.1872C8.33886 10.5134 8.91284 10.6875 9.5 10.6875C10.2874 10.6875 11.0425 10.3747 11.5992 9.81797C12.156 9.26123 12.4688 8.50611 12.4688 7.71875ZM7.71875 7.71875C7.71875 7.36645 7.82322 7.02207 8.01894 6.72914C8.21467 6.43622 8.49286 6.20791 8.81835 6.07309C9.14383 5.93827 9.50198 5.903 9.84751 5.97173C10.193 6.04046 10.5104 6.2101 10.7595 6.45922C11.0086 6.70833 11.1783 7.02572 11.247 7.37125C11.3158 7.71677 11.2805 8.07492 11.1457 8.40041C11.0108 8.72589 10.7825 9.00408 10.4896 9.19981C10.1967 9.39553 9.8523 9.5 9.5 9.5C9.02758 9.5 8.57451 9.31233 8.24047 8.97828C7.90642 8.64424 7.71875 8.19117 7.71875 7.71875Z"
                                        fill="#fff" />
                                </svg>

                                <span>{{ locationLabel }}</span>
                            </p>
                            }
                            <div class="te-card-price">
                                @if (exp?.all_in_one_price?.exp_price_exact > 0
                                || exp?.all_in_one_price?.exp_price > 0) {
                                <span class="te-card-amount">${{
                                    (exp?.all_in_one_price?.exp_price_exact ||
                                    exp?.all_in_one_price?.exp_price) |
                                    priceFormat }}</span>
                                <span class="te-card-price-label">/{{
                                    exp?.all_in_one_price?.price_label ||
                                    'Per Person'
                                    }}</span>
                                } @else {
                                <span class="te-card-price-label">View Price
                                    Options</span>
                                }
                            </div>
                            <div class="te-review-badge">
                                <span class="te-review-owl" aria-hidden="true">
                                    <svg width="29" height="29"
                                        viewBox="0 0 29 29" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_3571_8160)">
                                            <path
                                                d="M26.3049 10.4838L28.6462 7.93652H23.4542C20.8549 6.16102 17.7158 5.12695 14.3209 5.12695C10.9303 5.12695 7.8 6.16325 5.20506 7.93652H0L2.34133 10.4838C0.906217 11.7931 0.00654611 13.6793 0.00654611 15.7734C0.00654611 19.7254 3.21067 22.9295 7.16274 22.9295C9.04013 22.9295 10.7505 22.2055 12.0274 21.0218L14.3211 23.5192L16.6147 21.0239C17.8915 22.2076 19.5998 22.9295 21.4772 22.9295C25.4292 22.9295 28.6376 19.7253 28.6376 15.7733C28.6397 13.6771 27.7401 11.791 26.3049 10.4838ZM7.16481 20.6164C4.48963 20.6164 2.3218 18.4486 2.3218 15.7734C2.3218 13.0982 4.48968 10.9303 7.16481 10.9303C9.83993 10.9303 12.0078 13.0982 12.0078 15.7734C12.0078 18.4486 9.83993 20.6164 7.16481 20.6164ZM14.3231 15.6325C14.3231 12.4457 12.0057 9.7099 8.9468 8.54139C10.6008 7.8498 12.4154 7.4661 14.3209 7.4661C16.2265 7.4661 18.0431 7.8498 19.6973 8.54139C16.6406 9.71203 14.3231 12.4457 14.3231 15.6325ZM21.4793 20.6164C18.8041 20.6164 16.6362 18.4486 16.6362 15.7734C16.6362 13.0982 18.8041 10.9303 21.4793 10.9303C24.1545 10.9303 26.3223 13.0982 26.3223 15.7734C26.3223 18.4486 24.1544 20.6164 21.4793 20.6164ZM21.4793 13.2326C20.0767 13.2326 18.9407 14.3686 18.9407 15.7712C18.9407 17.1738 20.0767 18.3098 21.4793 18.3098C22.882 18.3098 24.0179 17.1738 24.0179 15.7712C24.0178 14.3708 22.8819 13.2326 21.4793 13.2326ZM9.70341 15.7734C9.70341 17.176 8.56741 18.3119 7.16486 18.3119C5.76231 18.3119 4.62631 17.1759 4.62631 15.7734C4.62631 14.3707 5.76231 13.2348 7.16486 13.2348C8.56741 13.2326 9.70341 14.3708 9.70341 15.7734Z"
                                                fill="#002712" />
                                        </g>
                                        <defs>
                                            <clippath id="clip0_3571_8160">
                                                <rect width="28.6462"
                                                    height="28.6462"
                                                    fill="white" />
                                            </clippath>
                                        </defs>
                                    </svg>

                                </span>
                                <span class="te-review-stars"
                                    aria-hidden="true">
                                    @for (star of [1,2,3,4,5]; track star) {
                                    <span class="te-review-dot"></span>
                                    }
                                </span>
                                <span class="te-review-meta">
                                    <span class="te-review-score">{{
                                        getTrendingReviewScore(exp) }}</span>
                                    <span class="te-review-count">({{
                                        getTrendingReviewCount(exp) }})</span>
                                </span>
                            </div>
                        </div>
                    </a>
                </swiper-slide>
                }
            </swiper-container>
            }
        </div>
    </div>
</section>

}

<section class="special-occasion-section">
    <div class="container">
        <div class="so-layout">
            <div class="so-content">
                <p class="sub-text">Perfect for Every</p>
                <h2 class="section-title">Special Occasion</h2>
                <p class="so-subtitle">Thoughtful gifts for every moment that
                    matters.</p>

                <div class="so-categories">
                    <a class="so-chip" routerLink="/gifts">
                        <span class="so-chip-icon" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20 12V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V12"
                                    stroke="#22C55E" stroke-width="1.6"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M22 7H2V12H22V7Z" stroke="#22C55E"
                                    stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M12 22V7" stroke="#22C55E"
                                    stroke-width="1.6" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C10 2 12 7 12 7Z"
                                    stroke="#22C55E" stroke-width="1.6"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C14 2 12 7 12 7Z"
                                    stroke="#22C55E" stroke-width="1.6"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span>Birthday Gifts</span>
                    </a>
                    <a class="so-chip" routerLink="/gifts">
                        <span class="so-chip-icon" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.1283 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.0621 22.0329 6.39464C21.7563 5.72718 21.351 5.12075 20.84 4.61V4.61Z"
                                    stroke="#EF4444" stroke-width="1.6"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span>Anniversary Gifts</span>
                    </a>
                    <a class="so-chip" routerLink="/gifts">
                        <span class="so-chip-icon" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="9" cy="13" r="5.25" stroke="#A855F7"
                                    stroke-width="1.6" />
                                <circle cx="15" cy="13" r="5.25"
                                    stroke="#A855F7" stroke-width="1.6" />
                                <path
                                    d="M9 4.5C9.5 3.5 10.5 3 12 3C13.5 3 14.5 3.5 15 4.5"
                                    stroke="#A855F7" stroke-width="1.6"
                                    stroke-linecap="round" />
                            </svg>
                        </span>
                        <span>Wedding Gifts</span>
                    </a>
                    <a class="so-chip" routerLink="/gifts">
                        <span class="so-chip-icon" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8 7V5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H14C14.5304 3 15.0391 3.21071 15.4142 3.58579C15.7893 3.96086 16 4.46957 16 5V7"
                                    stroke="#3B82F6" stroke-width="1.6"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <rect x="3" y="7" width="18" height="13" rx="2"
                                    stroke="#3B82F6" stroke-width="1.6" />
                                <path d="M3 12H21" stroke="#3B82F6"
                                    stroke-width="1.6" stroke-linecap="round" />
                                <path d="M12 12V14.5" stroke="#3B82F6"
                                    stroke-width="1.6" stroke-linecap="round" />
                            </svg>
                        </span>
                        <span>Corporate Gifts</span>
                    </a>
                    <a class="so-chip" routerLink="/gifts">
                        <span class="so-chip-icon" aria-hidden="true">
                            <svg width="24" height="24" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7 11L11 2C11.7956 2 12.5587 2.31607 13.1213 2.87868C13.6839 3.44129 14 4.20435 14 5V9H19.66C19.9499 8.99672 20.2371 9.0565 20.5016 9.17522C20.7661 9.29393 21.0016 9.46873 21.1919 9.68751C21.3821 9.90629 21.5225 10.1638 21.6033 10.4423C21.6842 10.7207 21.7035 11.0134 21.66 11.3L20.28 20.3C20.2077 20.7769 19.9654 21.2116 19.5979 21.524C19.2304 21.8364 18.7623 22.0055 18.28 22H7M7 11V22M7 11H4C3.46957 11 2.96086 11.2107 2.58579 11.5858C2.21071 11.9609 2 12.4696 2 13V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H7"
                                    stroke="#EF920F" stroke-width="1.5" />
                            </svg>

                        </span>
                        <span>Thank You Gifts</span>
                    </a>
                    <a class="so-chip" routerLink="/gifts">
                        <span class="so-chip-icon" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="5" width="18" height="16" rx="2"
                                    stroke="#7C3AED" stroke-width="1.6" />
                                <path d="M3 10H21" stroke="#7C3AED"
                                    stroke-width="1.6" stroke-linecap="round" />
                                <path d="M8 3V7M16 3V7" stroke="#7C3AED"
                                    stroke-width="1.6" stroke-linecap="round" />
                                <path
                                    d="M7.5 14H8.5M11.5 14H12.5M15.5 14H16.5M7.5 17.5H8.5M11.5 17.5H12.5"
                                    stroke="#7C3AED" stroke-width="1.6"
                                    stroke-linecap="round" />
                            </svg>
                        </span>
                        <span>Other Occasions</span>
                    </a>
                </div>
            </div>

            <div class="so-media">
                <img class="so-image" src='assets/images/special_occasion.webp'
                    alt="Special occasion gift moment" width="735" height="337"
                    loading="lazy" />
            </div>
        </div>
    </div>
</section>



<section class="influencer-section">
    <div class="container">
        <div class="influencer-container">
            <div class="row w-100 m-0">
                <div class="col-lg-6">
                    <div class="influencer-left">
                        <span
                            class="influencer-subtitle">{{influencerSecton?.name}}</span>
                        <h2 class="influencer-title">Wanna Collab With Us?</h2>
                        <p class="influencer-desc">
                            {{influencerSecton?.description}}
                        </p>
                        <div class="influencer-actions">
                            @if(!tokenkey){
                            <a routerLink="/influencers"
                                class="theme-btn">Become an Influencer</a>
                            }
                            <a routerLink="/list-influencers"
                                class="border-btn  bg-white">Explore
                                Influencers</a>
                        </div>
                        <div class="influencer-features">
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <svg width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M18.5794 14.6368C18.1335 13.7072 16.5383 12.4168 14.9971 11.17C14.1375 10.4752 13.3252 9.81817 12.8074 9.30034C12.6777 9.1697 12.4837 9.12803 12.3123 9.18958C11.9933 9.30509 11.7964 9.39407 11.6411 9.46316C11.4045 9.56918 11.3249 9.60516 11.0059 9.63734C10.9364 9.6442 10.8693 9.66634 10.8094 9.70219C10.7495 9.73803 10.6983 9.78669 10.6594 9.84466C9.99007 10.8453 9.29709 10.7601 8.83416 10.6049C8.68647 10.5557 8.65998 10.4922 8.64578 10.4316C8.54638 10.016 9.0453 9.04851 9.69186 8.4019C11.2303 6.86258 12.0236 6.47727 13.6992 7.22611C15.6002 8.07623 17.5049 8.74178 17.5239 8.74839C17.5826 8.76896 17.6448 8.77773 17.7069 8.77419C17.7691 8.77066 17.8299 8.7549 17.8859 8.72781C17.9419 8.70072 17.9921 8.66283 18.0334 8.61632C18.0748 8.56982 18.1065 8.51561 18.1269 8.4568C18.2121 8.20971 18.0824 7.9399 17.8353 7.85377C17.8163 7.84716 15.9495 7.19487 14.0864 6.36082C11.9156 5.39045 10.7247 6.02946 9.02347 7.73165C8.37593 8.37918 7.49644 9.68939 7.72364 10.6503C7.82114 11.0593 8.10896 11.3622 8.53684 11.5033C9.60945 11.8573 10.5883 11.5184 11.3173 10.5509C11.6183 10.5045 11.7821 10.4364 12.0282 10.3256C12.1377 10.2761 12.2482 10.2288 12.3596 10.1836C12.9011 10.692 13.6319 11.2836 14.4016 11.9056C15.7932 13.0312 17.3714 14.3074 17.7264 15.0458C17.9015 15.4103 17.7131 15.6479 17.5853 15.7568C17.3979 15.9177 17.1413 15.9688 17.0022 15.8713C16.8488 15.7662 16.6491 15.7596 16.491 15.8543C16.4131 15.9006 16.3503 15.9684 16.3098 16.0494C16.2694 16.1305 16.2531 16.2215 16.2628 16.3115C16.295 16.6126 16.0195 16.7849 15.9002 16.8445C15.5973 16.9979 15.2811 16.9714 15.1627 16.8616C15.0302 16.7385 14.8399 16.7025 14.6714 16.765C14.5029 16.8284 14.3855 16.9837 14.3684 17.1635C14.34 17.474 14.11 17.7722 13.8099 17.8887C13.665 17.9436 13.4549 17.9767 13.2665 17.8044C13.2087 17.7524 13.1391 17.7151 13.0638 17.696C12.9884 17.6769 12.9095 17.6764 12.8339 17.6946C12.7582 17.7131 12.6883 17.75 12.6303 17.802C12.5723 17.854 12.5281 17.9196 12.5016 17.9928C12.4836 18.0401 12.4429 18.1537 11.9998 18.1537C11.6846 18.1537 11.1175 17.9407 10.8401 17.7571C10.5079 17.5384 8.42417 15.9839 6.62453 14.4768C6.37177 14.2638 5.9344 13.8075 5.54815 13.4042C5.20543 13.0463 4.89209 12.7216 4.73114 12.5853C4.52949 12.4149 4.23128 12.4404 4.06372 12.6412C3.89522 12.8409 3.91981 13.1401 4.11959 13.3086C4.26634 13.4326 4.55035 13.7327 4.86369 14.0593C5.28593 14.5004 5.72232 14.9568 6.01583 15.2029C7.77858 16.6788 9.89728 18.2721 10.3195 18.5494C10.6679 18.7786 11.4186 19.1004 11.9999 19.1004C12.4666 19.1004 12.8254 18.9934 13.0743 18.7842C13.4076 18.914 13.7863 18.9149 14.1507 18.7729C14.5815 18.6063 14.9355 18.2702 15.1362 17.8631C15.5092 17.9426 15.9362 17.8868 16.3243 17.6918C16.704 17.5006 16.9785 17.208 17.1148 16.8663C17.4916 16.8861 17.8797 16.7527 18.2006 16.4772C18.7441 16.0124 18.8937 15.2891 18.5794 14.6368Z"
                                            fill="#E85325" />
                                        <path
                                            d="M10.1065 6.79297H5.84641C5.58512 6.79297 5.37305 7.00504 5.37305 7.26633C5.37305 7.52762 5.58512 7.73969 5.84641 7.73969H10.1065C10.3678 7.73969 10.5799 7.52762 10.5799 7.26633C10.5799 7.00504 10.3678 6.79297 10.1065 6.79297ZM19.9663 13.629C19.8196 13.4123 19.5261 13.3526 19.3093 13.5003L17.9253 14.4299C17.7085 14.5757 17.6507 14.8701 17.7966 15.0869C17.8401 15.1513 17.8988 15.2041 17.9674 15.2406C18.0361 15.277 18.1126 15.2961 18.1904 15.2962C18.2803 15.2962 18.3722 15.2706 18.4536 15.2157L19.8376 14.2861C20.0544 14.1402 20.1121 13.8459 19.9663 13.629ZM17.0278 15.8879C16.6889 15.6209 15.1732 14.0693 14.236 13.0923C14.0552 12.9029 13.7551 12.8963 13.5667 13.0781C13.3773 13.2589 13.3716 13.559 13.5525 13.7474C13.7958 14.0011 15.9419 16.2382 16.4408 16.632C16.5241 16.6977 16.6272 16.7334 16.7333 16.7333C16.8725 16.7333 17.0117 16.6708 17.1063 16.5525C17.2683 16.348 17.2332 16.0498 17.0278 15.8879ZM15.1363 16.8374C14.5692 16.3839 13.1445 14.8701 12.8226 14.5199C12.6446 14.3268 12.3464 14.3154 12.1532 14.4915C11.961 14.6685 11.9478 14.9686 12.1248 15.1608C12.1419 15.1788 13.8422 17.0144 14.5446 17.5768C14.6286 17.6435 14.7327 17.6798 14.8399 17.68C14.9782 17.68 15.1164 17.6184 15.2101 17.5029C15.373 17.2984 15.3398 17.0002 15.1363 16.8374ZM13.2524 17.7907C12.5774 17.2218 11.1962 15.7515 10.9264 15.4628C10.7474 15.2716 10.4473 15.2611 10.257 15.4401C10.0658 15.619 10.0563 15.9181 10.2343 16.1094C10.6225 16.525 11.944 17.9261 12.6418 18.5149C12.727 18.587 12.835 18.6266 12.9466 18.6266C13.081 18.6266 13.2155 18.5689 13.3092 18.4581C13.4777 18.2574 13.4521 17.9592 13.2524 17.7907Z"
                                            fill="#E85325" />
                                        <path
                                            d="M6.17212 5.976C5.36079 5.20727 2.11649 4.95828 1.14141 4.90055C1.00699 4.89393 0.882963 4.9384 0.788309 5.02835C0.741338 5.07261 0.703919 5.12601 0.678354 5.18527C0.652788 5.24453 0.639616 5.30839 0.639648 5.37293V13.8932C0.639648 14.1544 0.851722 14.3665 1.11301 14.3665H3.95308C4.15757 14.3665 4.33933 14.2349 4.40275 14.0399C4.47184 13.8278 6.10302 8.82176 6.31789 6.36034C6.33023 6.21643 6.2772 6.07443 6.17212 5.976ZM3.60753 13.4198H1.58633V5.88037C3.10767 6.00059 4.74924 6.26187 5.34565 6.55156C5.09479 8.62482 3.9597 12.3084 3.60753 13.4198ZM22.8869 5.84629C19.1702 5.84629 17.1083 6.79772 17.0221 6.83748C16.8991 6.89521 16.8072 7.0022 16.7694 7.13191C16.7315 7.26162 16.7504 7.40079 16.8214 7.51626C17.4065 8.45823 19.2383 13.6896 19.5905 14.9658C19.618 15.0656 19.6776 15.1537 19.76 15.2165C19.8425 15.2792 19.9432 15.3132 20.0468 15.3132H22.8869C23.1482 15.3132 23.3603 15.1011 23.3603 14.8398V6.31961C23.3603 6.25743 23.3481 6.19586 23.3243 6.1384C23.3006 6.08095 23.2657 6.02875 23.2217 5.98479C23.1778 5.94083 23.1256 5.90597 23.0681 5.8822C23.0106 5.85844 22.9491 5.84623 22.8869 5.84629ZM22.4136 14.3665H20.4009C19.9522 12.9048 18.6268 9.09343 17.8874 7.51816C18.6097 7.27299 20.1614 6.85168 22.4136 6.79869V14.3665Z"
                                            fill="#E85325" />
                                    </svg>

                                </div>
                                <div class="feature-text">
                                    <span
                                        class="feature-heading">Collaborate</span>
                                    <span class="feature-subheading">with
                                        Us</span>
                                </div>
                            </div>
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <svg width="20" height="20"
                                        viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M1.66675 1.6665V15.8332C1.66675 17.2165 2.78341 18.3332 4.16675 18.3332H18.3334"
                                            stroke="#E85325" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M4.16675 14.1668L7.99175 9.70017C8.62508 8.96684 9.75008 8.91683 10.4334 9.60849L11.2251 10.4002C11.9084 11.0835 13.0334 11.0418 13.6667 10.3085L17.5001 5.8335"
                                            stroke="#E85325" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>

                                </div>
                                <div class="feature-text">
                                    <span class="feature-heading">Grow</span>
                                    <span class="feature-subheading">your
                                        audience</span>
                                </div>
                            </div>
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <svg width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_2149_1261)">
                                            <path
                                                d="M22.2672 15.9407C21.7666 15.6983 21.2239 15.5549 20.6688 15.5183C20.9109 14.9197 21.0427 14.2822 21.0576 13.6367C21.1704 10.2407 18.48 7.77592 17.3352 6.71992L17.2152 6.61192C17.0496 6.45832 16.8984 6.30712 16.7568 6.15592C16.903 6.03286 17.0204 5.87927 17.1009 5.70595C17.1813 5.53263 17.2228 5.3438 17.2224 5.15272V5.12872C17.2215 4.86489 17.1414 4.6074 16.9925 4.3896C16.8436 4.1718 16.6328 4.00372 16.3872 3.90712C16.6622 3.14019 16.8545 2.34609 16.9608 1.53832C16.9775 1.40055 16.955 1.26087 16.896 1.13526C16.837 1.00966 16.7438 0.903209 16.6271 0.828088C16.5104 0.752967 16.3749 0.712211 16.2362 0.710484C16.0974 0.708757 15.961 0.746129 15.8424 0.818323C15.4747 1.02196 15.0817 1.1761 14.6736 1.27672C14.2802 1.37908 13.8671 1.37908 13.4736 1.27672C13.0629 1.17608 12.6674 1.02111 12.2976 0.815923C12.1784 0.743907 12.0412 0.707049 11.902 0.709596C11.7627 0.712144 11.627 0.753994 11.5104 0.830323C11.3946 0.904187 11.3023 1.00964 11.2445 1.13424C11.1867 1.25884 11.1657 1.39738 11.184 1.53352C11.292 2.34435 11.485 3.14155 11.76 3.91192C11.5139 4.00786 11.3023 4.17571 11.1529 4.3936C11.0035 4.61149 10.9232 4.86933 10.9224 5.13352V5.15752C10.9224 5.3708 10.9744 5.58088 11.0739 5.7695C11.1735 5.95813 11.3175 6.11961 11.4936 6.23992C11.3856 6.35512 11.2536 6.47992 11.1144 6.61192L10.9992 6.71992C9.84004 7.77592 7.16404 10.2383 7.27444 13.6343C7.27444 13.8119 7.29604 13.9823 7.31524 14.1527H5.44564V13.3823C5.44564 13.255 5.39507 13.1329 5.30505 13.0429C5.21503 12.9529 5.09294 12.9023 4.96564 12.9023H1.55764C1.43033 12.9023 1.30824 12.9529 1.21823 13.0429C1.12821 13.1329 1.07764 13.255 1.07764 13.3823V21.5663C1.07764 21.6936 1.12821 21.8157 1.21823 21.9057C1.30824 21.9958 1.43033 22.0463 1.55764 22.0463H4.96564C5.09294 22.0463 5.21503 21.9958 5.30505 21.9057C5.39507 21.8157 5.44564 21.6936 5.44564 21.5663V20.9423L10.6728 23.0519C11.0767 23.2038 11.5038 23.285 11.9352 23.2919C12.8952 23.2919 13.7352 22.8767 14.7168 22.3871L14.8272 22.3319H14.8512L22.2912 18.0575C22.485 17.956 22.6466 17.8025 22.7581 17.6143C22.8696 17.4261 22.9265 17.2106 22.9224 16.9919C22.9241 16.7726 22.8634 16.5574 22.7474 16.3712C22.6314 16.1851 22.4649 16.0358 22.2672 15.9407ZM12.3888 5.51992H12.24C12.1462 5.51992 12.0563 5.48283 11.9897 5.41674C11.9232 5.35064 11.8855 5.26091 11.8848 5.16712V5.14312C11.8839 5.09587 11.8924 5.04891 11.9098 5.00498C11.9272 4.96105 11.9532 4.92104 11.9863 4.88729C12.0194 4.85354 12.0589 4.82673 12.1024 4.80843C12.146 4.79013 12.1928 4.78071 12.24 4.78072H15.9096C16.0032 4.78072 16.0929 4.81789 16.1591 4.88406C16.2253 4.95022 16.2624 5.03995 16.2624 5.13352V5.15752C16.2637 5.20465 16.2555 5.25156 16.2384 5.29548C16.2212 5.3394 16.1954 5.37943 16.1626 5.41322C16.1297 5.447 16.0903 5.47385 16.0469 5.49218C16.0035 5.51051 15.9568 5.51994 15.9096 5.51992H12.3888ZM13.2192 2.21272C13.7775 2.36156 14.365 2.36156 14.9232 2.21272C15.273 2.1209 15.6149 2.00132 15.9456 1.85512C15.8192 2.52438 15.637 3.18188 15.4008 3.82072H12.7368C12.5024 3.18153 12.3209 2.52411 12.1944 1.85512C12.5262 2.00093 12.8688 2.12049 13.2192 2.21272ZM11.6472 7.43992L11.7648 7.33192C12.0553 7.06768 12.3264 6.78295 12.576 6.47992H15.756C16.0046 6.77862 16.2733 7.06007 16.56 7.32232L16.6824 7.43272C17.7312 8.39272 20.1912 10.6487 20.0928 13.6031C20.086 14.2981 19.9036 14.98 19.5624 15.5855C19.1943 15.6628 18.8372 15.7853 18.4992 15.9503L15.912 17.1959C15.8426 16.8186 15.6443 16.4772 15.351 16.2298C15.0577 15.9825 14.6876 15.8447 14.304 15.8399H11.52C10.657 14.9513 9.52161 14.3768 8.29444 14.2079C8.26186 14.0078 8.24182 13.8058 8.23444 13.6031C8.13844 10.6487 10.596 8.39992 11.6472 7.43992ZM2.04724 21.0959V13.8623H4.49524V21.0863L2.04724 21.0959ZM21.84 17.1911L14.4 21.4679L14.304 21.5159C12.9912 22.1711 12.1968 22.5671 11.028 22.1543L5.44564 19.9199V15.1199H7.51924C8.1654 15.1202 8.80419 15.2571 9.39363 15.5219C9.98307 15.7866 10.5098 16.1731 10.9392 16.6559C10.9842 16.7064 11.0392 16.7468 11.1009 16.7745C11.1625 16.8022 11.2293 16.8166 11.2968 16.8167H14.304C14.4639 16.8191 14.6179 16.8776 14.7389 16.9821C14.86 17.0865 14.9406 17.2301 14.9664 17.3879C14.9708 17.5206 14.9321 17.6511 14.856 17.7599C14.856 17.7599 14.856 17.7599 14.8416 17.7791C14.7841 17.8518 14.7112 17.911 14.6283 17.9524C14.5454 17.9939 14.4543 18.0167 14.3616 18.0191H8.99284C8.86553 18.0191 8.74344 18.0697 8.65342 18.1597C8.56341 18.2497 8.51284 18.3718 8.51284 18.4991C8.51284 18.6264 8.56341 18.7485 8.65342 18.8385C8.74344 18.9286 8.86553 18.9791 8.99284 18.9791H14.3568C14.5628 18.9798 14.7668 18.9397 14.9571 18.861C15.1475 18.7823 15.3203 18.6666 15.4656 18.5207C15.4968 18.4895 15.528 18.4559 15.5568 18.4223L18.9168 16.8047C19.2188 16.6514 19.5426 16.5453 19.8768 16.4903C20.5475 16.3932 21.2318 16.5011 21.84 16.7999C21.8741 16.8153 21.9029 16.8403 21.9229 16.8719C21.943 16.9034 21.9534 16.9402 21.9528 16.9775C21.9562 17.0202 21.9474 17.0629 21.9274 17.1007C21.9075 17.1385 21.8771 17.1699 21.84 17.1911Z"
                                                fill="#E85325" />
                                            <path
                                                d="M14.8801 13.2841H13.7761C13.7403 13.2844 13.7047 13.2776 13.6716 13.2642C13.6384 13.2507 13.6082 13.2307 13.5828 13.2055C13.5573 13.1803 13.5371 13.1503 13.5234 13.1172C13.5096 13.0842 13.5025 13.0487 13.5025 13.0129C13.5025 12.8856 13.4519 12.7635 13.3619 12.6735C13.2719 12.5835 13.1498 12.5329 13.0225 12.5329C12.8952 12.5329 12.7731 12.5835 12.6831 12.6735C12.5931 12.7635 12.5425 12.8856 12.5425 13.0129C12.5431 13.3397 12.6734 13.6528 12.9046 13.8836C13.1359 14.1145 13.4493 14.2441 13.7761 14.2441H13.8481V14.6041C13.8481 14.7314 13.8987 14.8535 13.9887 14.9435C14.0787 15.0335 14.2008 15.0841 14.3281 15.0841C14.4554 15.0841 14.5775 15.0335 14.6675 14.9435C14.7575 14.8535 14.8081 14.7314 14.8081 14.6041V14.2441H14.8801C15.0418 14.2441 15.2019 14.2123 15.3512 14.1504C15.5006 14.0885 15.6363 13.9978 15.7507 13.8835C15.865 13.7692 15.9557 13.6334 16.0176 13.4841C16.0794 13.3347 16.1113 13.1746 16.1113 13.0129V12.2161C16.1106 11.8898 15.9807 11.577 15.75 11.3462C15.5192 11.1155 15.2064 10.9855 14.8801 10.9849H13.7761C13.7403 10.9852 13.7047 10.9784 13.6716 10.965C13.6384 10.9515 13.6082 10.9315 13.5828 10.9063C13.5573 10.8811 13.5371 10.8511 13.5234 10.818C13.5096 10.785 13.5025 10.7495 13.5025 10.7137V9.9169C13.5031 9.84476 13.5322 9.77578 13.5835 9.72499C13.6347 9.6742 13.7039 9.6457 13.7761 9.6457H14.8801C14.9518 9.64633 15.0204 9.6751 15.0712 9.72583C15.1219 9.77655 15.1507 9.84517 15.1513 9.9169C15.1513 10.0442 15.2019 10.1663 15.2919 10.2563C15.3819 10.3463 15.504 10.3969 15.6313 10.3969C15.7586 10.3969 15.8807 10.3463 15.9707 10.2563C16.0607 10.1663 16.1113 10.0442 16.1113 9.9169C16.1113 9.75522 16.0794 9.59512 16.0176 9.44574C15.9557 9.29637 15.865 9.16064 15.7507 9.04631C15.6363 8.93199 15.5006 8.8413 15.3512 8.77942C15.2019 8.71755 15.0418 8.6857 14.8801 8.6857H14.8081V8.3257C14.8081 8.1984 14.7575 8.07631 14.6675 7.98629C14.5775 7.89627 14.4554 7.8457 14.3281 7.8457C14.2008 7.8457 14.0787 7.89627 13.9887 7.98629C13.8987 8.07631 13.8481 8.1984 13.8481 8.3257V8.6857H13.7761C13.4493 8.6857 13.1359 8.81534 12.9046 9.04617C12.6734 9.27699 12.5431 9.59015 12.5425 9.9169V10.7137C12.5431 11.0405 12.6734 11.3536 12.9046 11.5844C13.1359 11.8153 13.4493 11.9449 13.7761 11.9449H14.8801C14.9518 11.9455 15.0204 11.9743 15.0712 12.025C15.1219 12.0758 15.1507 12.1444 15.1513 12.2161V13.0129C15.1513 13.0848 15.1227 13.1538 15.0718 13.2047C15.021 13.2555 14.952 13.2841 14.8801 13.2841Z"
                                                fill="#E85325" />
                                        </g>
                                        <defs>
                                            <clippath id="clip0_2149_1261">
                                                <rect width="24" height="24"
                                                    fill="white" />
                                            </clippath>
                                        </defs>
                                    </svg>

                                </div>
                                <div class="feature-text">
                                    <span class="feature-heading">Earn</span>
                                    <span
                                        class="feature-subheading">Commission</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="influencer-right">
                        <img
                            [ngSrc]="influencerSecton?.image_url + '?width=500'"
                            alt="Influencer Collaboration" height="400"
                            width="510" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>




@if (brandLogos?.length > 0) {
<section class="brand-partners-section">
    <div class="container">
        <div class="bp-head">
            <p class="sub-text">Trusted By</p>
            <h2 class="section-title">Brand Partners</h2>
        </div>
        <div class="carousel-container">
            <div class="carousel-track">
                <div
                    class="partner-logo"
                    *ngFor="let record of duplicatedBrandLogos; let i = index; trackBy: trackByLogo"
                    [attr.aria-hidden]="i >= brandLogos.length ? 'true' : null"
                >
                    @if (record?.image_url) {
                        <img class="bp-logo" [src]="record.image_url + '?width=200'" [alt]="record?.name || 'Brand partner'"
                            loading="lazy" width="160" height="64" />
                    }
                </div>
            </div>
        </div>
    </div>
</section>
}

@if (spurfectRewardsSection) {
<section class="spurfect-rewards-home-section" aria-label="Spurfect Rewards">
    <div class="container">
        <div class="sr-home-banner"
            style="background-image: url('assets/images/spurfect_bg.jpg')">
            <div class="sr-home-banner__shade" aria-hidden="true"></div>
            <div class="sr-home-banner__inner">
                <div class="sr-home-banner__copy">
                    <div class="left-box">
                        <img src="../../../assets/images/earn-img.png" alt="">
                            @if (spurfectRewardsDescriptionHtml) {
                                <p class="sr-home-banner__desc"
                                    [innerHTML]="spurfectRewardsDescriptionHtml"></p>
                                }
                    </div>
                    
                    <div class="sr-home-banner__actions">
                        <a routerLink="/spurfect-rewards" class="sr-home-banner__cta">
                            How Badges Work
                            <span class="sr-home-banner__cta-icon" aria-hidden="true">
                                <svg width="9" height="8" viewBox="0 0 9 8" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M-4.87975e-05 3.66313C-4.87911e-05 3.51731 0.0578755 3.37747 0.160981 3.27437C0.264086 3.17126 0.403927 3.11334 0.54974 3.11334L6.99106 3.11334L4.58152 0.957434C4.47382 0.859965 4.40906 0.723834 4.4014 0.578777C4.39375 0.433719 4.4438 0.291526 4.54065 0.183257C4.63749 0.0749887 4.77324 0.00944484 4.91825 0.000943126C5.06326 -0.00755859 5.20574 0.0416729 5.31457 0.137883L8.79657 3.25335C8.85434 3.30492 8.90056 3.36812 8.93221 3.4388C8.96386 3.50948 8.98022 3.58605 8.98022 3.66349C8.98022 3.74094 8.96386 3.81751 8.93221 3.88819C8.90056 3.95887 8.85434 4.02206 8.79657 4.07363L5.31457 7.1891C5.26084 7.23773 5.19802 7.27525 5.12974 7.29951C5.06145 7.32378 4.98904 7.3343 4.91668 7.33048C4.84431 7.32666 4.77341 7.30857 4.70806 7.27725C4.64271 7.24593 4.5842 7.202 4.53588 7.14799C4.48757 7.09397 4.45041 7.03094 4.42655 6.96252C4.40268 6.89409 4.39258 6.82162 4.39682 6.74928C4.40106 6.67693 4.41956 6.60614 4.45126 6.54097C4.48296 6.47581 4.52723 6.41755 4.58152 6.36955L6.99106 4.21291L0.54974 4.21291C0.403927 4.21291 0.264086 4.15499 0.160981 4.05188C0.0578755 3.94878 -4.88039e-05 3.80894 -4.87975e-05 3.66313Z"
                                        fill="white" />
                                </svg>
                            </span>
                        </a>
                        <div class="sr-home-banner__tiers" aria-hidden="true">
                            <img src="../../../assets/images/earn-img03.png" alt="">
                            <img src="../../../assets/images/earn-img02.png" alt="">
                            <img src="../../../assets/images/earn-img01.png" alt="">

                        </div>
                    </div>
                </div>
                @if (spurfectRewardsSection?.image_url) {
                <div class="sr-home-banner__visual">
                    <img class="sr-home-banner__characters"
                        [src]="spurfectRewardsSection.image_url + '?width=900'"
                        [alt]="spurfectRewardsSection.name || 'Spurfect Rewards'"
                              loading="lazy" />
                </div>
                }
            </div>
        </div>
    </div>
</section>
}

<section class="promo-combo-section">
    <div class="container">
        <div class="promo-combo-grid">
            <article class="promo-card promo-card--registry"
                [style.background-image]="wedding_registry_background ? 'url(' + wedding_registry_background + '?width=900)' : null">
                <div class="promo-card__overlay"></div>
                <div class="promo-card__content">
                    <p
                        class="promo-card__eyebrow promo-card__eyebrow--light">Wedding
                        Registry</p>
                    <h2 class="promo-card__title promo-card__title--light">For
                        Experiences</h2>
                    @if (wedding_registry?.description) {
                    <p class="promo-card__text promo-card__text--light"
                        [innerHtml]="wedding_registry.description"></p>
                    } @else {
                    <p class="promo-card__text promo-card__text--light">Engaged
                        couples register for honeymoon experiences
                        ranging from waterfall rappelling in Costa Rica to
                        dinner cruises in Maui. Couples also register
                        for experiences in their home state such as kayaking,
                        winery tours, concert tickets, couple's
                        massages.</p>
                    }
                    @if (!tokenkey) {
                    <a class="promo-card__btn promo-card__btn--primary"
                        routerLink="/registration/wedding-couple">Create
                        Registry</a>
                    }
                </div>
            </article>

            <div class="promo-combo-side">
                <article class="promo-card promo-card--gift">
                    <div class="promo-card__content">
                        <p
                            class="promo-card__kicker promo-card__kicker--light">Send
                            or print an</p>
                        <h2
                            class="promo-card__title promo-card__title--script promo-card__title--light">E-Gift
                            Card</h2>
                        <p class="promo-card__text promo-card__text--light">The
                            perfect last-minute gift for any occasion.
                            Instant, personal and meaningful</p>
                        <button type="button"
                            class="promo-card__btn promo-card__btn--light"
                            (click)="add_gift_certificate()">Send Gift
                            Card</button>
                    </div>
                    <div class="promo-card__media promo-card__media--gift">
                        <img src='assets/images/home_gift_card.png'
                            alt="Spur Experiences gift card"
                            width="250" height="280" loading="lazy" />
                    </div>
                </article>

                <article class="promo-card promo-card--app">
                    <div class="promo-card__content">
                        <p
                            class="promo-card__kicker promo-card__kicker--accent">Download
                            the</p>
                        <h2 class="promo-card__title promo-card__title--app">
                            <span class="promo-card__script">Spur Experiences
                                App</span>
                        </h2>
                        <p class="promo-card__text"> Explore gift ideas and
                            discover unforgettable experiences on the go. </p>
                        <div class="promo-card__stores">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.vebolife&pcampaignid=web_share"
                                target="_blank" rel="noopener noreferrer">
                                <img src="assets/images/mobile_app_badge.png"
                                    alt="Get it on Google Play" width="135"
                                    height="40" loading="lazy" />
                            </a>
                            <a
                                href="https://apps.apple.com/in/app/spur-experiences/id1123434344"
                                target="_blank"
                                rel="noopener noreferrer">
                                <img src="assets/images/app_store.png"
                                    alt="Download on the App Store" width="135"
                                    height="40" loading="lazy" />
                            </a>
                        </div>
                    </div>
                    <div class="promo-card__media promo-card__media--app">
                        <img
                            [src]="web_cdn_url + 'assets/images/mobile_app_image.png'"
                            alt="Spur Experiences mobile app"
                            width="200" height="280" loading="lazy" />
                    </div>
                </article>
            </div>
        </div>
    </div>
</section>




<section class="partner-section">
    <div class="container">
        <div class="partner-card">
            <div class="partner-card__content">
                <h2 class="partner-card__title">
                    <span class="sub-text">Become an</span>
                    <span class="section-title">Experience Partner</span>
                </h2>
                <p class="partner-card__desc">
                    {{ providerSection?.description ||
                    'Showcase your unique experiences with us to reach more users and offer exceptional experiences crafted for travellers worldwide.'
                    }}
                </p>

                <div class="partner-card__features">
                    <div class="partner-card__feature">
                        <span class="partner-card__check" aria-hidden="true">
                            <svg width="12" height="12" viewBox="0 0 12 12"
                                fill="none">
                                <path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="#fff"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span class="partner-card__feature-text">Diversify Your
                            Customer Outreach</span>
                    </div>
                    <div class="partner-card__feature">
                        <span class="partner-card__check" aria-hidden="true">
                            <svg width="12" height="12" viewBox="0 0 12 12"
                                fill="none">
                                <path d="M2.5 6.2L4.8 8.5L9.5 3.5" stroke="#fff"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                        <span class="partner-card__feature-text">New Revenue
                            Channel</span>
                    </div>
                </div>

                <div class="partner-card__actions">
                    <a routerLink="/experience"
                        class="partner-card__btn partner-card__btn--primary">Shop
                        Now</a>
                    @if (!tokenkey) {
                    <a routerLink="/registration/experience-provider"
                        class="partner-card__btn partner-card__btn--outline">Become
                        a Partner</a>
                    }
                </div>
            </div>
            <!-- Background photo via CSS on .partner-card — keep markup for layout only -->
            <div class="partner-card__media" aria-hidden="true"></div>
        </div>
    </div>
</section>




@if (guest_about_spur?.section_data?.length > 0) {
<section class="testimonial-section">
    <div class="container">
        <div class="wl-head">
            <div class="wl-titles">
                <p class="sub-text">The Wall of Love</p>
                <h2 class="section-title">What Our Guests Are Saying About
                    Spur</h2>
                <p class="wl-subtitle">Discover why thousands of adventurers
                    trust Spur for
                    unforgettable experiences.</p>
            </div>
            <div class="wl-rating"
                aria-label="Average rating 5.0 out of 5 based on 1411 reviews">
                <div class="wl-rating-row">
                    <div class="wl-rating-score">
                        <span class="wl-rating-value">4.6</span>
                        <span class="wl-rating-max">/5</span>
                    </div>
                    <div>
                        <div class="wl-rating-stars" aria-hidden="true">
                            @for (star of [1,2,3,4,5]; track star) {
                            <svg width="24" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M12 2.5l2.6 5.9 6.4.7-4.8 4.3 1.4 6.3L12 16.8 6.4 19.7l1.4-6.3L3 9.1l6.4-.7L12 2.5z"
                                    fill="#E85325" />
                            </svg>
                            }
                        </div>
                        <p class="wl-rating-count">Based on 1,411 Reviews</p>
                    </div>
                </div>

            </div>
        </div>

        <div class="wl-slider-wrap" (mouseenter)="pauseSwiper('swiperEl5')"
            (mouseleave)="resumeSwiper('swiperEl5')">
            <button type="button" class="wl-nav wl-nav--prev"
                (click)="slidePrev('swiperEl5')"
                aria-label="Previous testimonial">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.1659 8.89089H6.32912L10.8474 4.37259L9.69967 3.23291L3.2334 9.69918L9.69967 16.1654L10.8393 15.0258L6.32912 10.5075H16.1659V8.89089Z"
                        fill="currentColor" />
                </svg>

            </button>
            <button type="button" class="wl-nav wl-nav--next"
                (click)="slideNext('swiperEl5')"
                aria-label="Next testimonial">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.23287 8.89138H13.0697L8.55137 4.37308L9.69914 3.2334L16.1654 9.69967L9.69914 16.1659L8.55946 15.0263L13.0697 10.5079H3.23287V8.89138Z"
                        fill="currentColor" />
                </svg>

            </button>

            <swiper-container #swiperEl5 init="false"
                class="custom-swiper wl-swiper">
                <swiper-slide
                    *ngFor="let record of guest_about_spur?.section_data; trackBy: trackByTestimonial">
                    <article class="wl-card">
                        <div class="wl-card-top">
                            <div class="wl-user">
                                <div class="wl-avatar">
                                    @if (record?.image_url) {
                                    <img [src]="record.image_url + '?width=96'"
                                        [alt]="record?.title || 'Guest'"
                                        width="48" height="48" loading="lazy" />
                                    } @else {
                                    <span class="wl-avatar-fallback"
                                        aria-hidden="true">{{ (record?.title ||
                                        'G').charAt(0) }}</span>
                                    }
                                </div>
                                <div class="wl-user-meta">
                                    <h3 class="wl-user-name">{{ record?.title
                                        }}</h3>
                                    <p class="wl-user-time">{{
                                        getTimeAgo(record?.updated_at ||
                                        record?.created_at) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="wl-card-body">
                            <p class="wl-quote"
                                [innerHtml]="record?.description"></p>
                        </div>
                        <span class="wl-quote-mark" aria-hidden="true">”</span>
                    </article>
                </swiper-slide>
            </swiper-container>
        </div>
    </div>
</section>

}


<section class="follow-social-block">
    <div class="container">
        <div class="stw-head">
            <div class="stw-titles">
                <p class="sub-text">Memories Made Around The World</p>
                <h2 class="section-title">See The World With
                    <span>Spur</span></h2>
                <p class="stw-subtitle">Follow us <a class="stw-handle"
                        [href]="instagramUrl" target="_blank"
                        rel="noopener noreferrer">@SpurExperiences</a> on
                    Instagram for daily inspiration, travel ideas,
                    and community stories.</p>
            </div>
            <a class="stw-tiktok" [href]="tikTokUrl" target="_blank"
                rel="noopener noreferrer">
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_5530_1547)">
                        <path
                            d="M7.0088 7.87544V7.09484C6.73595 7.05822 6.45901 7.03564 6.17645 7.03564C2.77092 7.03564 0 9.75619 0 13.1003C0 15.1521 1.04389 16.9677 2.63705 18.0653C1.609 16.9817 0.978483 15.5304 0.978483 13.9361C0.978483 10.6401 3.67072 7.95219 7.00931 7.87544H7.0088Z"
                            fill="#25F4EE" />
                        <path
                            d="M7.15372 16.706C8.67331 16.706 9.91289 15.5191 9.9691 14.0407L9.97472 0.836769H12.4314C12.3803 0.565367 12.3522 0.286439 12.3522 0.000488281H8.99674L8.99112 13.2044C8.93492 14.6828 7.69534 15.8698 6.17575 15.8698C5.70362 15.8698 5.25858 15.7539 4.86719 15.5517C5.37968 16.2495 6.21254 16.706 7.15372 16.706ZM17.0208 5.31817V4.58423C16.0837 4.58423 15.2105 4.31082 14.4783 3.84176C15.1303 4.5767 16.0158 5.10697 17.0208 5.31817Z"
                            fill="#25F4EE" />
                        <path
                            d="M14.4795 3.84128C13.7652 3.0361 13.3314 1.98511 13.3314 0.835785H12.4326C12.6692 2.09096 13.428 3.16804 14.4795 3.84128ZM6.17646 10.3304C4.62111 10.3304 3.35547 11.573 3.35547 13.1001C3.35547 14.1636 3.97015 15.0877 4.8679 15.5512C4.53322 15.0957 4.33395 14.5388 4.33395 13.9358C4.33395 12.4088 5.59959 11.1661 7.15495 11.1661C7.44517 11.1661 7.72364 11.2133 7.9873 11.2941V7.93037C7.71444 7.89375 7.43751 7.87118 7.15495 7.87118C7.10589 7.87118 7.05786 7.87369 7.00932 7.87469V10.4578C6.74567 10.377 6.4672 10.3299 6.17697 10.3299L6.17646 10.3304Z"
                            fill="#FE2C55" />
                        <path
                            d="M17.0217 5.31769V7.8782C15.2819 7.8782 13.6693 7.33189 12.3531 6.4043V13.1001C12.3531 16.4442 9.58216 19.1642 6.17663 19.1642C4.8604 19.1642 3.64024 18.7569 2.63672 18.0651C3.76491 19.2545 5.37238 20 7.1546 20C10.5606 20 13.3311 17.2795 13.3311 13.9358V7.24058C14.6473 8.16817 16.2599 8.71448 17.9997 8.71448V5.41953C17.664 5.41953 17.337 5.38391 17.0217 5.31769Z"
                            fill="#FE2C55" />
                        <path
                            d="M12.3525 13.1002V6.40445C13.6687 7.33204 15.2813 7.87835 17.0211 7.87835V5.31784C16.016 5.10664 15.1305 4.57688 14.4786 3.84143C13.427 3.16819 12.6682 2.09161 12.4317 0.835938H9.97498L9.96936 14.0398C9.91316 15.5183 8.67358 16.7052 7.15399 16.7052C6.21281 16.7052 5.37995 16.2487 4.86746 15.5509C3.9697 15.0868 3.35502 14.1627 3.35502 13.0997C3.35502 11.5726 4.62066 10.33 6.17602 10.33C6.46624 10.33 6.74471 10.3772 7.00837 10.4579V7.87484C3.66977 7.9516 0.977539 10.6395 0.977539 13.9355C0.977539 15.5298 1.60806 16.9811 2.63611 18.0647C3.63912 18.756 4.85979 19.1639 6.17602 19.1639C9.58155 19.1639 12.3525 16.4433 12.3525 13.0997V13.1002Z"
                            fill="black" />
                    </g>
                    <defs>
                        <clippath id="clip0_5530_1547">
                            <rect width="18" height="20" fill="white" />
                        </clippath>
                    </defs>
                </svg>

                <span class="stw-tiktok-text">tiktok</span>
                <span class="stw-tiktok-arrow" aria-hidden="true">
                    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                        <path d="M2.5 7H11.5M11.5 7L7.5 3M11.5 7L7.5 11"
                            stroke="currentColor" stroke-width="1.6"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
            </a>
        </div>

        <div class="stw-feed-card">
            <div class="stw-feed-head">
                <span class="stw-ig-icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <defs>
                            <lineargradient id="stwIgGrad" x1="3" y1="21"
                                x2="21" y2="3"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#F58529" />
                                <stop offset="0.35" stop-color="#DD2A7B" />
                                <stop offset="0.7" stop-color="#8134AF" />
                                <stop offset="1" stop-color="#515BD4" />
                            </lineargradient>
                        </defs>
                        <rect x="2.5" y="2.5" width="19" height="19" rx="5.5"
                            stroke="url(#stwIgGrad)"
                            stroke-width="1.8" />
                        <circle cx="12" cy="12" r="4.2" stroke="url(#stwIgGrad)"
                            stroke-width="1.8" />
                        <circle cx="17.3" cy="6.7" r="1.1"
                            fill="url(#stwIgGrad)" />
                    </svg>
                </span>
                <span class="stw-ig-label">Instagram</span>
            </div>
            @if (isBrowser) {
            <div class="stw-feed-frame">
                <iframe
                    src="https://widgets.sociablekit.com/instagram-feed/iframe/25658196"
                    title="Spur Instagram feed"
                    frameborder="0" width="100%" height="420"
                    loading="lazy"></iframe>
            </div>
            }
        </div>
    </div>
</section>


<section class="offer-section">
    <div class="container">
        <div class="offer-banner">
            <div class="offer-banner-left">
                <span class="offer-banner-icon" aria-hidden="true">
                    <svg width="112" height="101" viewBox="0 0 112 101"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.0453439 95.616C18.5279 94.8849 51.3968 85.2968 35.0122 52.7929C14.5314 12.163 12.627 113.911 65.4094 48.6688"
                            stroke="white" stroke-linecap="round"
                            stroke-dasharray="5 5" />
                        <g clip-path="url(#clip0_3571_8608)">
                            <path
                                d="M110.222 0.0690358L70.9327 12.9073C69.8231 13.2699 69.6626 14.7792 70.6725 15.3663L85.5204 24.0001C85.7495 24.1334 86.0127 24.1965 86.2773 24.1816C86.5419 24.1668 86.7964 24.0747 87.0092 23.9166L91.183 20.817L88.0834 24.9908C87.9253 25.2036 87.8332 25.4581 87.8184 25.7227C87.8035 25.9874 87.8666 26.2506 87.9999 26.4797L96.6337 41.3276C97.2215 42.3383 98.7304 42.1761 99.0928 41.0674L111.931 1.7778C112.275 0.722818 111.272 -0.27424 110.222 0.0690358ZM97.4561 37.3516L90.7911 25.8894L98.8279 15.0674C99.0216 14.8065 99.115 14.4846 99.0911 14.1605C99.0673 13.8364 98.9277 13.5317 98.698 13.3019C98.4682 13.0721 98.1634 12.9326 97.8393 12.9087C97.5153 12.8849 97.1934 12.9783 96.9324 13.172L86.1104 21.2089L74.6484 14.5438L108.526 3.47385L97.4561 37.3516ZM84.2248 29.6911L75.229 38.6868C74.6999 39.2158 73.8421 39.216 73.313 38.6868C72.7839 38.1578 72.7839 37.2999 73.313 36.7709L82.3088 27.7752C82.838 27.2462 83.6959 27.246 84.2248 27.7752C84.7539 28.3042 84.7539 29.1621 84.2248 29.6911ZM72.3406 30.0315C71.8115 29.5024 71.8115 28.6446 72.3406 28.1155L75.8902 24.5659C76.4193 24.0367 77.2771 24.0367 77.8062 24.5659C78.3353 25.095 78.3353 25.9528 77.8062 26.4818L74.2566 30.0315C73.7276 30.5605 72.8697 30.5606 72.3406 30.0315ZM87.4341 34.1937C87.9632 34.7227 87.9632 35.5806 87.4341 36.1096L83.8844 39.6592C83.7587 39.7852 83.6094 39.8852 83.445 39.9533C83.2806 40.0214 83.1044 40.0563 82.9264 40.0561C81.7302 40.0561 81.1126 38.5991 81.9685 37.7433L85.5182 34.1937C86.0472 33.6645 86.905 33.6645 87.4341 34.1937Z"
                                fill="white" />
                        </g>
                        <defs>
                            <clippath id="clip0_3571_8608">
                                <rect width="42" height="42" fill="white"
                                    transform="translate(70)" />
                            </clippath>
                        </defs>
                    </svg>

                </span>
                <div class="offer-banner-copy">
                    <h2 class="offer-banner-title">Unlock 10% Off!</h2>
                    <p class="offer-banner-text">
                        Sign up with Spur for exclusive discounts and early
                        access to our latest offers and insights.
                    </p>
                </div>
            </div>
            <button type="button" class="offer-banner-btn"
                (click)="openSignUpPopup()">Sign Up</button>
        </div>
    </div>
</section>


<!-- Custom Magnific Popup -->
<div id="video-popup-wrapper" hidden>
    <div id="magni-overlay"></div>
    <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready">
        <div class="mfp-container mfp-s-ready mfp-iframe-holder">
            <div class="mfp-content">
                <div class="mfp-iframe-scaler">
                    <button title="Close (Esc)" type="button"
                        (click)="closeVideoPopup($event)"
                        class="mfp-close">×</button>
                    <iframe id="videoIframe" class="mfp-iframe" frameborder="0"
                        allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</div>
}
